import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: ID;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  /** The `DateTime` scalar represents an ISO-8601 compliant date time type. */
  DateTime: Date;
  TimeSpan: Seconds;
  Uuid: string;
};

export enum ApplyPolicy {
  AfterResolver = 'AFTER_RESOLVER',
  BeforeResolver = 'BEFORE_RESOLVER'
}

export enum AuthorizationPolicy {
  Admin = 'ADMIN',
  Authenticated = 'AUTHENTICATED',
  Read = 'READ',
  Write = 'WRITE'
}

export type AuthorizeDirective = {
  __typename: 'AuthorizeDirective';
  apply: ApplyPolicy;
  policy?: Maybe<Scalars['String']>;
  roles?: Maybe<Array<Scalars['String']>>;
};

export type Chain = {
  __typename: 'Chain';
  id: Scalars['ID'];
  sourceItemId: Scalars['ID'];
  targetItemId: Scalars['ID'];
};

export type Change = {
  __typename: 'Change';
  affectedItem?: Maybe<Item>;
  affectedResource?: Maybe<Resource>;
  changeType: ChangeType;
  date: Scalars['DateTime'];
  id: Scalars['ID'];
  userName: Scalars['String'];
};

export enum ChangeType {
  AddItem = 'ADD_ITEM',
  AddResource = 'ADD_RESOURCE',
  DeleteItem = 'DELETE_ITEM',
  DeleteResource = 'DELETE_RESOURCE',
  MoveFromClipboard = 'MOVE_FROM_CLIPBOARD',
  MoveItem = 'MOVE_ITEM',
  MoveToClipboard = 'MOVE_TO_CLIPBOARD',
  ResizeItem = 'RESIZE_ITEM'
}

export type Clipboard = {
  __typename: 'Clipboard';
  id: Scalars['ID'];
  items: Array<Item>;
  userEmail: Scalars['String'];
};

export type CloneItemCommandInput = {
  id: Scalars['ID'];
};

export enum Colorway {
  Blue = 'BLUE',
  BrightBlue = 'BRIGHT_BLUE',
  BrightGreen = 'BRIGHT_GREEN',
  BrightOrange = 'BRIGHT_ORANGE',
  BrightPink = 'BRIGHT_PINK',
  BrightYellow = 'BRIGHT_YELLOW',
  Orange = 'ORANGE',
  Pink = 'PINK',
  Purple = 'PURPLE',
  Teal = 'TEAL',
  Violet = 'VIOLET'
}

export type CreateChainCommandInput = {
  sourceItemId: Scalars['ID'];
  targetItemId: Scalars['ID'];
};

export type CreateProcessCommandInput = {
  duration: Scalars['TimeSpan'];
  lag?: InputMaybe<Scalars['TimeSpan']>;
  resourceId?: InputMaybe<Scalars['ID']>;
  runId?: InputMaybe<Scalars['ID']>;
  startTime?: InputMaybe<Scalars['DateTime']>;
};

export type CreateProcessPayload = {
  __typename: 'CreateProcessPayload';
  process: Process;
};

export type CreateResourceCommandInput = {
  name: Scalars['String'];
  resourceTypeId: Scalars['ID'];
};

export type CreateRunCommandInput = {
  duration: Scalars['TimeSpan'];
  lag?: InputMaybe<Scalars['TimeSpan']>;
  resourceId: Scalars['ID'];
  startTime: Scalars['DateTime'];
};

export type CreateRunPayload = {
  __typename: 'CreateRunPayload';
  run: Run;
};

export type CreateSinkCommandInput = {
  resourceId: Scalars['ID'];
  startTime: Scalars['DateTime'];
};

export type CreateSinkPayload = {
  __typename: 'CreateSinkPayload';
  sink: Sink;
};

export type CreateSourceCommandInput = {
  resourceId: Scalars['ID'];
  startTime: Scalars['DateTime'];
};

export type CreateSourcePayload = {
  __typename: 'CreateSourcePayload';
  source: Source;
};

export type CustomField = {
  __typename: 'CustomField';
  id: Scalars['ID'];
  name: Scalars['String'];
  value: Scalars['String'];
};

export type DeleteChainCommandInput = {
  id?: InputMaybe<Scalars['ID']>;
  sourceItemId?: InputMaybe<Scalars['ID']>;
  targetItemId?: InputMaybe<Scalars['ID']>;
};

export type DeleteItemCommandInput = {
  id: Scalars['ID'];
};

export type DeleteItemPayload = {
  __typename: 'DeleteItemPayload';
  message: Scalars['String'];
  success: Scalars['Boolean'];
};

export type DeleteResourceCommandInput = {
  id: Scalars['ID'];
};

export type ExtendItemUsingDurationCommandInput = {
  duration: Scalars['TimeSpan'];
  itemId: Scalars['ID'];
};

export type FilterResourceCommandInput = {
  hide: Scalars['Boolean'];
  resourceId?: InputMaybe<Scalars['ID']>;
  selectAll: Scalars['Boolean'];
};

export type Item = {
  colorway: Colorway;
  conflictCount: Scalars['Int'];
  customFields: Array<CustomField>;
  deleted: Scalars['Boolean'];
  description: Scalars['String'];
  externalId?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  key: Scalars['Uuid'];
  lastPositioned?: Maybe<Scalars['DateTime']>;
  locked: Scalars['Boolean'];
  resourceType: ResourceType;
  subtitle: Scalars['String'];
  timelineUsage?: Maybe<TimelineUsage>;
  title: Scalars['String'];
};

export type ItemsWrapper = {
  __typename: 'ItemsWrapper';
  items: Array<Item>;
};

export type MoveItemOnTimelineCommandInput = {
  assertState?: InputMaybe<MoveItemOnTimelineStateAssertionInput>;
  itemId: Scalars['ID'];
  resourceId?: InputMaybe<Scalars['ID']>;
  startTime: Scalars['DateTime'];
};

export type MoveItemOnTimelineError = OptimisticConcurrencyError;

export type MoveItemOnTimelinePayload = {
  __typename: 'MoveItemOnTimelinePayload';
  error?: Maybe<MoveItemOnTimelineError>;
  message: Scalars['String'];
};

export type MoveItemOnTimelineStateAssertionInput = {
  resourceId?: InputMaybe<Scalars['ID']>;
  startTime: Scalars['DateTime'];
};

export type MoveItemToClipboardCommandInput = {
  itemId: Scalars['ID'];
};

export type MoveItemsOnTimelineCommandInput = {
  movements: Array<MoveItemsOnTimelineMovementInput>;
};

export type MoveItemsOnTimelineMovementInput = {
  assertState?: InputMaybe<MoveItemOnTimelineStateAssertionInput>;
  itemId: Scalars['ID'];
  startTime: Scalars['DateTime'];
};

export type MoveItemsOnTimelinePayload = {
  __typename: 'MoveItemsOnTimelinePayload';
  error?: Maybe<MoveItemOnTimelineError>;
  message: Scalars['String'];
};

export type MoveProcessInRunCommandInput = {
  duration?: InputMaybe<Scalars['TimeSpan']>;
  endTime?: InputMaybe<Scalars['DateTime']>;
  index?: InputMaybe<Scalars['Int']>;
  processId: Scalars['ID'];
  runId?: InputMaybe<Scalars['ID']>;
};

export type Mutation = {
  __typename: 'Mutation';
  cloneItem: Scalars['Boolean'];
  createChain: Scalars['ID'];
  createProcess: CreateProcessPayload;
  createResource: Scalars['Boolean'];
  createRun: CreateRunPayload;
  createSink: CreateSinkPayload;
  createSource: CreateSourcePayload;
  deleteChain: Scalars['Boolean'];
  deleteItem: DeleteItemPayload;
  deleteResource: Scalars['Boolean'];
  extendItemUsingDuration: Scalars['Boolean'];
  filterResource: Scalars['Boolean'];
  moveItemOnTimeline: MoveItemOnTimelinePayload;
  moveItemToClipboard: Scalars['Boolean'];
  moveItemsOnTimeline: MoveItemsOnTimelinePayload;
  moveProcessInRun: Scalars['Boolean'];
  renameResource: Scalars['Boolean'];
  reorderResources: Scalars['Boolean'];
  resizeItemOnTimeline: Scalars['Boolean'];
  restoreItem: Scalars['Boolean'];
  setDefaultResourceSchedule: Scalars['Boolean'];
  setItemColorway: Scalars['Boolean'];
  setItemCustomField: Scalars['Boolean'];
  setItemDescription: Scalars['Boolean'];
  setItemLag: Scalars['Boolean'];
  setItemLocked: Scalars['Boolean'];
  setProcessTaskIcon: Scalars['Boolean'];
  setResourceItemTypesAllowed: Scalars['Boolean'];
  setResourceOverlapsAllowed: Scalars['Boolean'];
  setResourceResourceType: Scalars['Boolean'];
  setResourceSalesOrderLane: Scalars['Boolean'];
  setResourceSchedule: Scalars['Boolean'];
  syncSalesOrdersNow: Scalars['Boolean'];
};


export type MutationCloneItemArgs = {
  input: CloneItemCommandInput;
};


export type MutationCreateChainArgs = {
  input: CreateChainCommandInput;
};


export type MutationCreateProcessArgs = {
  input: CreateProcessCommandInput;
};


export type MutationCreateResourceArgs = {
  input: CreateResourceCommandInput;
};


export type MutationCreateRunArgs = {
  input: CreateRunCommandInput;
};


export type MutationCreateSinkArgs = {
  input: CreateSinkCommandInput;
};


export type MutationCreateSourceArgs = {
  input: CreateSourceCommandInput;
};


export type MutationDeleteChainArgs = {
  input: DeleteChainCommandInput;
};


export type MutationDeleteItemArgs = {
  input: DeleteItemCommandInput;
};


export type MutationDeleteResourceArgs = {
  input: DeleteResourceCommandInput;
};


export type MutationExtendItemUsingDurationArgs = {
  input: ExtendItemUsingDurationCommandInput;
};


export type MutationFilterResourceArgs = {
  input: FilterResourceCommandInput;
};


export type MutationMoveItemOnTimelineArgs = {
  input: MoveItemOnTimelineCommandInput;
};


export type MutationMoveItemToClipboardArgs = {
  input: MoveItemToClipboardCommandInput;
};


export type MutationMoveItemsOnTimelineArgs = {
  input: MoveItemsOnTimelineCommandInput;
};


export type MutationMoveProcessInRunArgs = {
  input: MoveProcessInRunCommandInput;
};


export type MutationRenameResourceArgs = {
  input: RenameResourceCommandInput;
};


export type MutationReorderResourcesArgs = {
  input: ReorderResourcesCommandInput;
};


export type MutationResizeItemOnTimelineArgs = {
  input: ResizeItemOnTimelineCommandInput;
};


export type MutationRestoreItemArgs = {
  input: RestoreItemCommandInput;
};


export type MutationSetDefaultResourceScheduleArgs = {
  input: SetDefaultResourceScheduleCommandInput;
};


export type MutationSetItemColorwayArgs = {
  input: SetItemColorwayCommandInput;
};


export type MutationSetItemCustomFieldArgs = {
  input: SetItemCustomFieldCommandInput;
};


export type MutationSetItemDescriptionArgs = {
  input: SetItemDescriptionCommandInput;
};


export type MutationSetItemLagArgs = {
  input: SetItemLagCommandInput;
};


export type MutationSetItemLockedArgs = {
  input: SetItemLockedCommandInput;
};


export type MutationSetProcessTaskIconArgs = {
  input: SetProcessTaskIconCommandInput;
};


export type MutationSetResourceItemTypesAllowedArgs = {
  input: SetResourceItemTypesAllowedCommandInput;
};


export type MutationSetResourceOverlapsAllowedArgs = {
  input: SetResourceOverlapsAllowedCommandInput;
};


export type MutationSetResourceResourceTypeArgs = {
  input: SetResourceResourceTypeCommandInput;
};


export type MutationSetResourceScheduleArgs = {
  input: SetResourceScheduleCommandInput;
};


export type MutationSetResourceSalesOrderLaneArgs = {
  input: SetResourceSalesOrderLaneCommandInput;
};

export type OptimisticConcurrencyError = {
  __typename: 'OptimisticConcurrencyError';
  message: Scalars['String'];
};

export type Process = Item & {
  __typename: 'Process';
  colorway: Colorway;
  conflictCount: Scalars['Int'];
  customFields: Array<CustomField>;
  deleted: Scalars['Boolean'];
  description: Scalars['String'];
  duration: Scalars['TimeSpan'];
  externalId?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  inputs: Array<Item>;
  inventoryEntityId?: Maybe<Scalars['ID']>;
  inventoryWorkstationId?: Maybe<Scalars['ID']>;
  key: Scalars['Uuid'];
  lag?: Maybe<Scalars['TimeSpan']>;
  lastPositioned?: Maybe<Scalars['DateTime']>;
  locked: Scalars['Boolean'];
  outputs: Array<Item>;
  resourceType: ResourceType;
  runUsage?: Maybe<RunUsage>;
  subtitle: Scalars['String'];
  taskIconId?: Maybe<Scalars['ID']>;
  timelineUsage?: Maybe<TimelineUsage>;
  title: Scalars['String'];
};

export type Query = {
  __typename: 'Query';
  changes: Array<Change>;
  clipboard: Clipboard;
  currentUser: UserContext;
  /** Get all chains relating to the specified `Item`. */
  fullChain: Array<Chain>;
  /** Gets an `Item` by id. */
  item?: Maybe<Item>;
  myResourceFilter: ResourceFilter;
  resource: Resource;
  resourceTypes: Array<ResourceType>;
  resources: Array<Resource>;
  salesOrderSyncStatus: SalesOrderSyncStatus;
  searchItems: SearchItemsResult;
};


export type QueryChangesArgs = {
  count: Scalars['Int'];
  itemId?: InputMaybe<Scalars['ID']>;
};


export type QueryFullChainArgs = {
  id: Scalars['ID'];
};


export type QueryItemArgs = {
  id: Scalars['ID'];
};


export type QueryResourceArgs = {
  id: Scalars['ID'];
};


export type QueryResourcesArgs = {
  useMyFilter?: InputMaybe<Scalars['Boolean']>;
};


export type QuerySearchItemsArgs = {
  months: Scalars['Int'];
  search: Scalars['String'];
  take: Scalars['Int'];
};

export type RenameResourceCommandInput = {
  id: Scalars['ID'];
  name: Scalars['String'];
};

export type ReorderResourcesCommandInput = {
  id: Scalars['ID'];
  newIndex: Scalars['Int'];
};

export type ResizeItemOnTimelineCommandInput = {
  endTime: Scalars['DateTime'];
  itemId: Scalars['ID'];
  startTime: Scalars['DateTime'];
};

export type Resource = {
  __typename: 'Resource';
  allowOverlappingItems: Scalars['Boolean'];
  allowProcesses: Scalars['Boolean'];
  allowReservations: Scalars['Boolean'];
  allowRuns: Scalars['Boolean'];
  allowSinks: Scalars['Boolean'];
  allowSources: Scalars['Boolean'];
  defaultColorway: Colorway;
  /** Gets the default schedule for this resource */
  defaultSchedule: Array<ResourceScheduleRange>;
  displayIndex: Scalars['Int'];
  id: Scalars['ID'];
  inventoryWorkstationId?: Maybe<Scalars['ID']>;
  /** Get items for this resource. */
  items: Array<Item>;
  name: Scalars['String'];
  /** Get processes for this resource. */
  processes: Array<Process>;
  resourceType: ResourceType;
  resourceTypeId: Scalars['ID'];
  /** Get runs for this resource. */
  runs: Array<Run>;
  salesOrderLane: Scalars['Boolean'];
  /** Gets the schedule for this resource */
  schedule: Array<ResourceScheduleRange>;
  /** Get sinks for this resource. */
  sinks: Array<Sink>;
  /** Get sources for this resource. */
  sources: Array<Source>;
};


export type ResourceItemsArgs = {
  endTime: Scalars['DateTime'];
  startTime: Scalars['DateTime'];
};


export type ResourceProcessesArgs = {
  endTime: Scalars['DateTime'];
  startTime: Scalars['DateTime'];
};


export type ResourceRunsArgs = {
  endTime: Scalars['DateTime'];
  startTime: Scalars['DateTime'];
};


export type ResourceScheduleArgs = {
  endTime: Scalars['DateTime'];
  startTime: Scalars['DateTime'];
};


export type ResourceSinksArgs = {
  endTime: Scalars['DateTime'];
  startTime: Scalars['DateTime'];
};


export type ResourceSourcesArgs = {
  endTime: Scalars['DateTime'];
  startTime: Scalars['DateTime'];
};

export enum ResourceFieldType {
  Boolean = 'BOOLEAN',
  Number = 'NUMBER',
  String = 'STRING'
}

export type ResourceFilter = {
  __typename: 'ResourceFilter';
  id: Scalars['ID'];
  items: Array<ResourceFilterItem>;
  userEmail?: Maybe<Scalars['String']>;
};

export type ResourceFilterItem = {
  __typename: 'ResourceFilterItem';
  id: Scalars['ID'];
  resource: Resource;
};

export type ResourceScheduleRange = {
  __typename: 'ResourceScheduleRange';
  endTime: Scalars['DateTime'];
  startTime: Scalars['DateTime'];
};

export type ResourceScheduleRangeInput = {
  endTime: Scalars['DateTime'];
  startTime: Scalars['DateTime'];
};

export type ResourceType = {
  __typename: 'ResourceType';
  id: Scalars['ID'];
  name: Scalars['String'];
  processData: ResourceTypeData;
  reservationData: ResourceTypeData;
  runData: ResourceTypeData;
  sinkData: ResourceTypeData;
  sourceData: ResourceTypeData;
};

export type ResourceTypeData = {
  __typename: 'ResourceTypeData';
  fields: Array<ResourceTypeField>;
};

export type ResourceTypeField = {
  __typename: 'ResourceTypeField';
  name: Scalars['String'];
  type: ResourceFieldType;
};

export type ResourcesWrapper = {
  __typename: 'ResourcesWrapper';
  resources: Array<Resource>;
};

export type RestoreItemCommandInput = {
  id: Scalars['ID'];
};

export type Run = Item & {
  __typename: 'Run';
  colorway: Colorway;
  conflictCount: Scalars['Int'];
  customFields: Array<CustomField>;
  deleted: Scalars['Boolean'];
  description: Scalars['String'];
  duration: Scalars['TimeSpan'];
  externalId?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  inputs: Array<Item>;
  key: Scalars['Uuid'];
  lag?: Maybe<Scalars['TimeSpan']>;
  lastPositioned?: Maybe<Scalars['DateTime']>;
  locked: Scalars['Boolean'];
  outputs: Array<Item>;
  resourceType: ResourceType;
  runUsages: Array<RunUsage>;
  subtitle: Scalars['String'];
  timelineUsage?: Maybe<TimelineUsage>;
  title: Scalars['String'];
};

export type RunUsage = {
  __typename: 'RunUsage';
  id: Scalars['ID'];
  offset: Scalars['TimeSpan'];
  process: Process;
  runId: Scalars['ID'];
};

export type SearchItemsResult = {
  __typename: 'SearchItemsResult';
  items: Array<SearchItemsResultItem>;
};

export type SearchItemsResultItem = {
  __typename: 'SearchItemsResultItem';
  customField: CustomField;
  item: Item;
};

export type SetDefaultResourceScheduleCommandInput = {
  from: Scalars['DateTime'];
  resourceId: Scalars['ID'];
  schedule: Array<ResourceScheduleRangeInput>;
};

export type SetItemColorwayCommandInput = {
  colorway: Colorway;
  itemId: Scalars['ID'];
};

export type SetItemCustomFieldCommandInput = {
  itemId: Scalars['ID'];
  name: Scalars['String'];
  value: Scalars['String'];
};

export type SetItemDescriptionCommandInput = {
  description: Scalars['String'];
  itemId: Scalars['ID'];
};

export type SetItemLagCommandInput = {
  itemId?: InputMaybe<Scalars['ID']>;
  lag?: InputMaybe<Scalars['TimeSpan']>;
};

export type SetItemLockedCommandInput = {
  itemId: Scalars['ID'];
  locked: Scalars['Boolean'];
};

export type SetProcessTaskIconCommandInput = {
  processId: Scalars['ID'];
  taskIconId?: InputMaybe<Scalars['ID']>;
};

export type SetResourceItemTypesAllowedCommandInput = {
  allowProcesses?: InputMaybe<Scalars['Boolean']>;
  allowReservations?: InputMaybe<Scalars['Boolean']>;
  allowRuns?: InputMaybe<Scalars['Boolean']>;
  allowSinks?: InputMaybe<Scalars['Boolean']>;
  allowSources?: InputMaybe<Scalars['Boolean']>;
  id: Scalars['ID'];
};

export type SetResourceOverlapsAllowedCommandInput = {
  allowed: Scalars['Boolean'];
  id: Scalars['ID'];
};

export type SetResourceResourceTypeCommandInput = {
  resourceId: Scalars['ID'];
  resourceTypeId: Scalars['ID'];
};

export type SetResourceScheduleCommandInput = {
  from: Scalars['DateTime'];
  resourceId: Scalars['ID'];
  schedule: Array<ResourceScheduleRangeInput>;
  to: Scalars['DateTime'];
};

export type SetResourceSalesOrderLaneCommandInput = {
  enabled: Scalars['Boolean'];
  resourceId: Scalars['ID'];
};

export type SalesOrderSyncStatus = {
  __typename: 'SalesOrderSyncStatus';
  lastError?: Maybe<Scalars['String']>;
  lastRunAt?: Maybe<Scalars['DateTime']>;
  rowCount: Scalars['Int'];
  watermark?: Maybe<Scalars['String']>;
};

export type Sink = Item & {
  __typename: 'Sink';
  colorway: Colorway;
  conflictCount: Scalars['Int'];
  customFields: Array<CustomField>;
  deleted: Scalars['Boolean'];
  description: Scalars['String'];
  externalId?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  inputs: Array<Item>;
  key: Scalars['Uuid'];
  lag?: Maybe<Scalars['TimeSpan']>;
  lastPositioned?: Maybe<Scalars['DateTime']>;
  locked: Scalars['Boolean'];
  outputs: Array<Item>;
  resourceType: ResourceType;
  subtitle: Scalars['String'];
  timelineUsage?: Maybe<TimelineUsage>;
  title: Scalars['String'];
};

export type Source = Item & {
  __typename: 'Source';
  colorway: Colorway;
  conflictCount: Scalars['Int'];
  customFields: Array<CustomField>;
  deleted: Scalars['Boolean'];
  description: Scalars['String'];
  externalId?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  inputs: Array<Item>;
  key: Scalars['Uuid'];
  lastPositioned?: Maybe<Scalars['DateTime']>;
  locked: Scalars['Boolean'];
  outputs: Array<Item>;
  resourceType: ResourceType;
  subtitle: Scalars['String'];
  timelineUsage?: Maybe<TimelineUsage>;
  title: Scalars['String'];
};

export type Subscription = {
  __typename: 'Subscription';
  /** Informs clients when items change their in-conflict status. */
  itemConflictStatusChanged: ItemsWrapper;
  /** Informs clients when an item is created. */
  itemCreated: ItemsWrapper;
  /**
   * Informs clients when a field/the description/the colorway/output
   * buffer etc of an item changes.
   */
  itemDataChanged: ItemsWrapper;
  /** Informs clients when an item is deleted. */
  itemDeleted: ItemsWrapper;
  /**
   * Informs clients when an item's start time, end time, or resource/run
   * changes. This may happen when an item is moved, resized, a duration
   * is changed, or it is moved in/out of runs.
   */
  itemMoved: ItemsWrapper;
  /**
   * Informs clients when a clipboard's item list has been changed due to
   * a removed item. This happens when an item is moved out of the
   * clipboard.
   */
  itemMovedFromClipboard: ItemsWrapper;
  /**
   * Informs clients when a clipboard's item list has been appended to.
   * This happens when an item is moved to the the clipboard.
   */
  itemMovedToClipboard: ItemsWrapper;
  /**
   * Informs clients when a resource is changed. This could mean that
   * it's name has changed, it has changed it's vertical order (would
   * then return all resources), item restrictions on the resource have
   * changed, or other similar changes. Note that this does not include
   * item related operations on the resource or schedule changes.
   */
  resourceChanged: ResourcesWrapper;
  /** Informs clients when a resource is created. */
  resourceCreated: ResourcesWrapper;
  /** Informs clients when a resource is deleted. */
  resourceDeleted: ResourcesWrapper;
  /**
   * Informs clients when a resource's default or concrete schedule
   * changes.
   */
  resourceScheduleChanged: ResourcesWrapper;
};

export type TimelineUsage = {
  __typename: 'TimelineUsage';
  endTime: Scalars['DateTime'];
  id: Scalars['ID'];
  resource: Resource;
  resourceId: Scalars['ID'];
  startTime: Scalars['DateTime'];
};

/**
 * The GraphQL user context for the current request. The user context is accessible in field resolvers and
 * validation rules using context.UserContext.As<GraphQLUserContext>().
 */
export type UserContext = {
  __typename: 'UserContext';
  /** The e-mail of the logged in user. */
  email?: Maybe<Scalars['String']>;
  /** The name of the logged in user. */
  name?: Maybe<Scalars['String']>;
  /** The policies that apply to the logged in user. */
  policies: Array<AuthorizationPolicy>;
};

export type GetChainQueryVariables = Exact<{
  itemId: Scalars['ID'];
}>;


export type GetChainQuery = { __typename: 'Query', fullChain: Array<{ __typename: 'Chain', id: ID, sourceItemId: ID, targetItemId: ID }> };

export type CreateChainMutationVariables = Exact<{
  input: CreateChainCommandInput;
}>;


export type CreateChainMutation = { __typename: 'Mutation', createChain: ID };

export type DeleteChainMutationVariables = Exact<{
  input: DeleteChainCommandInput;
}>;


export type DeleteChainMutation = { __typename: 'Mutation', deleteChain: boolean };

export type GetItemInputsQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type GetItemInputsQuery = { __typename: 'Query', item?: { __typename: 'Process', id: ID, conflictCount: number, inputs: Array<{ __typename: 'Process', id: ID, title: string, colorway: Colorway } | { __typename: 'Run', id: ID, title: string, colorway: Colorway } | { __typename: 'Sink', id: ID, title: string, colorway: Colorway } | { __typename: 'Source', id: ID, title: string, colorway: Colorway }>, outputs: Array<{ __typename: 'Process', id: ID, title: string, colorway: Colorway } | { __typename: 'Run', id: ID, title: string, colorway: Colorway } | { __typename: 'Sink', id: ID, title: string, colorway: Colorway } | { __typename: 'Source', id: ID, title: string, colorway: Colorway }> } | { __typename: 'Run', id: ID, conflictCount: number, inputs: Array<{ __typename: 'Process', id: ID, title: string, colorway: Colorway } | { __typename: 'Run', id: ID, title: string, colorway: Colorway } | { __typename: 'Sink', id: ID, title: string, colorway: Colorway } | { __typename: 'Source', id: ID, title: string, colorway: Colorway }>, outputs: Array<{ __typename: 'Process', id: ID, title: string, colorway: Colorway } | { __typename: 'Run', id: ID, title: string, colorway: Colorway } | { __typename: 'Sink', id: ID, title: string, colorway: Colorway } | { __typename: 'Source', id: ID, title: string, colorway: Colorway }> } | { __typename: 'Sink', id: ID, conflictCount: number, inputs: Array<{ __typename: 'Process', id: ID, title: string, colorway: Colorway } | { __typename: 'Run', id: ID, title: string, colorway: Colorway } | { __typename: 'Sink', id: ID, title: string, colorway: Colorway } | { __typename: 'Source', id: ID, title: string, colorway: Colorway }>, outputs: Array<{ __typename: 'Process', id: ID, title: string, colorway: Colorway } | { __typename: 'Run', id: ID, title: string, colorway: Colorway } | { __typename: 'Sink', id: ID, title: string, colorway: Colorway } | { __typename: 'Source', id: ID, title: string, colorway: Colorway }> } | { __typename: 'Source', id: ID, conflictCount: number, inputs: Array<{ __typename: 'Process', id: ID, title: string, colorway: Colorway } | { __typename: 'Run', id: ID, title: string, colorway: Colorway } | { __typename: 'Sink', id: ID, title: string, colorway: Colorway } | { __typename: 'Source', id: ID, title: string, colorway: Colorway }>, outputs: Array<{ __typename: 'Process', id: ID, title: string, colorway: Colorway } | { __typename: 'Run', id: ID, title: string, colorway: Colorway } | { __typename: 'Sink', id: ID, title: string, colorway: Colorway } | { __typename: 'Source', id: ID, title: string, colorway: Colorway }> } | null };

type InputOutput_Process_Fragment = { __typename: 'Process', conflictCount: number, inputs: Array<{ __typename: 'Process', id: ID, title: string, colorway: Colorway } | { __typename: 'Run', id: ID, title: string, colorway: Colorway } | { __typename: 'Sink', id: ID, title: string, colorway: Colorway } | { __typename: 'Source', id: ID, title: string, colorway: Colorway }>, outputs: Array<{ __typename: 'Process', id: ID, title: string, colorway: Colorway } | { __typename: 'Run', id: ID, title: string, colorway: Colorway } | { __typename: 'Sink', id: ID, title: string, colorway: Colorway } | { __typename: 'Source', id: ID, title: string, colorway: Colorway }> };

type InputOutput_Run_Fragment = { __typename: 'Run', conflictCount: number, inputs: Array<{ __typename: 'Process', id: ID, title: string, colorway: Colorway } | { __typename: 'Run', id: ID, title: string, colorway: Colorway } | { __typename: 'Sink', id: ID, title: string, colorway: Colorway } | { __typename: 'Source', id: ID, title: string, colorway: Colorway }>, outputs: Array<{ __typename: 'Process', id: ID, title: string, colorway: Colorway } | { __typename: 'Run', id: ID, title: string, colorway: Colorway } | { __typename: 'Sink', id: ID, title: string, colorway: Colorway } | { __typename: 'Source', id: ID, title: string, colorway: Colorway }> };

type InputOutput_Sink_Fragment = { __typename: 'Sink', conflictCount: number, inputs: Array<{ __typename: 'Process', id: ID, title: string, colorway: Colorway } | { __typename: 'Run', id: ID, title: string, colorway: Colorway } | { __typename: 'Sink', id: ID, title: string, colorway: Colorway } | { __typename: 'Source', id: ID, title: string, colorway: Colorway }>, outputs: Array<{ __typename: 'Process', id: ID, title: string, colorway: Colorway } | { __typename: 'Run', id: ID, title: string, colorway: Colorway } | { __typename: 'Sink', id: ID, title: string, colorway: Colorway } | { __typename: 'Source', id: ID, title: string, colorway: Colorway }> };

type InputOutput_Source_Fragment = { __typename: 'Source', conflictCount: number, inputs: Array<{ __typename: 'Process', id: ID, title: string, colorway: Colorway } | { __typename: 'Run', id: ID, title: string, colorway: Colorway } | { __typename: 'Sink', id: ID, title: string, colorway: Colorway } | { __typename: 'Source', id: ID, title: string, colorway: Colorway }>, outputs: Array<{ __typename: 'Process', id: ID, title: string, colorway: Colorway } | { __typename: 'Run', id: ID, title: string, colorway: Colorway } | { __typename: 'Sink', id: ID, title: string, colorway: Colorway } | { __typename: 'Source', id: ID, title: string, colorway: Colorway }> };

export type InputOutputFragment = InputOutput_Process_Fragment | InputOutput_Run_Fragment | InputOutput_Sink_Fragment | InputOutput_Source_Fragment;

export type GetAdditionalItemQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type GetAdditionalItemQuery = { __typename: 'Query', item?: { __typename: 'Process', lag?: Seconds | null, id: ID, timelineUsage?: { __typename: 'TimelineUsage', id: ID, startTime: Date, endTime: Date, resourceId: ID } | null } | { __typename: 'Run', lag?: Seconds | null, id: ID, timelineUsage?: { __typename: 'TimelineUsage', id: ID, startTime: Date, endTime: Date, resourceId: ID } | null } | { __typename: 'Sink', id: ID, timelineUsage?: { __typename: 'TimelineUsage', id: ID, startTime: Date, endTime: Date, resourceId: ID } | null } | { __typename: 'Source', id: ID, timelineUsage?: { __typename: 'TimelineUsage', id: ID, startTime: Date, endTime: Date, resourceId: ID } | null } | null };

export type ChangesQueryVariables = Exact<{
  count: Scalars['Int'];
  itemId?: InputMaybe<Scalars['ID']>;
}>;


export type ChangesQuery = { __typename: 'Query', changes: Array<{ __typename: 'Change', id: ID, userName: string, date: Date, changeType: ChangeType, affectedItem?: { __typename: 'Process', id: ID, title: string, deleted: boolean } | { __typename: 'Run', id: ID, title: string, deleted: boolean } | { __typename: 'Sink', id: ID, title: string, deleted: boolean } | { __typename: 'Source', id: ID, title: string, deleted: boolean } | null, affectedResource?: { __typename: 'Resource', id: ID, name: string } | null }> };

export type ClipboardQueryVariables = Exact<{ [key: string]: never; }>;


export type ClipboardQuery = { __typename: 'Query', clipboard: { __typename: 'Clipboard', id: ID, userEmail: string, items: Array<{ __typename: 'Process', taskIconId?: ID | null, duration: Seconds, inventoryWorkstationId?: ID | null, id: ID, externalId?: string | null, title: string, subtitle: string, colorway: Colorway, locked: boolean, timelineUsage?: { __typename: 'TimelineUsage', id: ID, startTime: Date, endTime: Date, resourceId: ID } | null } | { __typename: 'Run', duration: Seconds, id: ID, externalId?: string | null, title: string, subtitle: string, colorway: Colorway, locked: boolean, runUsages: Array<{ __typename: 'RunUsage', id: ID, offset: Seconds, process: { __typename: 'Process', id: ID, title: string, lag?: Seconds | null, duration: Seconds, colorway: Colorway, taskIconId?: ID | null, inventoryWorkstationId?: ID | null } }>, timelineUsage?: { __typename: 'TimelineUsage', id: ID, startTime: Date, endTime: Date, resourceId: ID } | null } | { __typename: 'Sink', id: ID, externalId?: string | null, title: string, subtitle: string, colorway: Colorway, locked: boolean, timelineUsage?: { __typename: 'TimelineUsage', id: ID, startTime: Date, endTime: Date, resourceId: ID } | null } | { __typename: 'Source', id: ID, externalId?: string | null, title: string, subtitle: string, colorway: Colorway, locked: boolean, timelineUsage?: { __typename: 'TimelineUsage', id: ID, startTime: Date, endTime: Date, resourceId: ID } | null }> } };

export type ItemMovedToClipboardSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type ItemMovedToClipboardSubscription = { __typename: 'Subscription', itemMovedToClipboard: { __typename: 'ItemsWrapper', items: Array<{ __typename: 'Process', duration: Seconds, lag?: Seconds | null, taskIconId?: ID | null, inventoryWorkstationId?: ID | null, id: ID, externalId?: string | null, title: string, subtitle: string, conflictCount: number, lastPositioned?: Date | null, colorway: Colorway, locked: boolean, runUsage?: { __typename: 'RunUsage', id: ID } | null, timelineUsage?: { __typename: 'TimelineUsage', id: ID, startTime: Date, endTime: Date, resourceId: ID } | null } | { __typename: 'Run', duration: Seconds, lag?: Seconds | null, id: ID, externalId?: string | null, title: string, subtitle: string, conflictCount: number, lastPositioned?: Date | null, colorway: Colorway, locked: boolean, runUsages: Array<{ __typename: 'RunUsage', id: ID, offset: Seconds, process: { __typename: 'Process', id: ID, title: string, subtitle: string, colorway: Colorway, lastPositioned?: Date | null, conflictCount: number, duration: Seconds, lag?: Seconds | null, taskIconId?: ID | null, inventoryWorkstationId?: ID | null, timelineUsage?: { __typename: 'TimelineUsage', id: ID, startTime: Date, endTime: Date, resourceId: ID } | null } }>, timelineUsage?: { __typename: 'TimelineUsage', id: ID, startTime: Date, endTime: Date, resourceId: ID } | null } | { __typename: 'Sink', lag?: Seconds | null, id: ID, externalId?: string | null, title: string, subtitle: string, conflictCount: number, lastPositioned?: Date | null, colorway: Colorway, locked: boolean, timelineUsage?: { __typename: 'TimelineUsage', id: ID, startTime: Date, endTime: Date, resourceId: ID } | null } | { __typename: 'Source', id: ID, externalId?: string | null, title: string, subtitle: string, conflictCount: number, lastPositioned?: Date | null, colorway: Colorway, locked: boolean, timelineUsage?: { __typename: 'TimelineUsage', id: ID, startTime: Date, endTime: Date, resourceId: ID } | null }> } };

export type ItemMovedFromClipboardSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type ItemMovedFromClipboardSubscription = { __typename: 'Subscription', itemMovedFromClipboard: { __typename: 'ItemsWrapper', items: Array<{ __typename: 'Process', duration: Seconds, lag?: Seconds | null, taskIconId?: ID | null, inventoryWorkstationId?: ID | null, id: ID, externalId?: string | null, title: string, subtitle: string, conflictCount: number, lastPositioned?: Date | null, colorway: Colorway, locked: boolean, runUsage?: { __typename: 'RunUsage', id: ID } | null, timelineUsage?: { __typename: 'TimelineUsage', id: ID, startTime: Date, endTime: Date, resourceId: ID } | null } | { __typename: 'Run', duration: Seconds, lag?: Seconds | null, id: ID, externalId?: string | null, title: string, subtitle: string, conflictCount: number, lastPositioned?: Date | null, colorway: Colorway, locked: boolean, runUsages: Array<{ __typename: 'RunUsage', id: ID, offset: Seconds, process: { __typename: 'Process', id: ID, title: string, subtitle: string, colorway: Colorway, lastPositioned?: Date | null, conflictCount: number, duration: Seconds, lag?: Seconds | null, taskIconId?: ID | null, inventoryWorkstationId?: ID | null, timelineUsage?: { __typename: 'TimelineUsage', id: ID, startTime: Date, endTime: Date, resourceId: ID } | null } }>, timelineUsage?: { __typename: 'TimelineUsage', id: ID, startTime: Date, endTime: Date, resourceId: ID } | null } | { __typename: 'Sink', lag?: Seconds | null, id: ID, externalId?: string | null, title: string, subtitle: string, conflictCount: number, lastPositioned?: Date | null, colorway: Colorway, locked: boolean, timelineUsage?: { __typename: 'TimelineUsage', id: ID, startTime: Date, endTime: Date, resourceId: ID } | null } | { __typename: 'Source', id: ID, externalId?: string | null, title: string, subtitle: string, conflictCount: number, lastPositioned?: Date | null, colorway: Colorway, locked: boolean, timelineUsage?: { __typename: 'TimelineUsage', id: ID, startTime: Date, endTime: Date, resourceId: ID } | null }> } };

export type GetItemQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type GetItemQuery = { __typename: 'Query', item?: { __typename: 'Process', duration: Seconds, lag?: Seconds | null, taskIconId?: ID | null, inventoryEntityId?: ID | null, id: ID, key: string, externalId?: string | null, title: string, subtitle: string, description: string, colorway: Colorway, locked: boolean, conflictCount: number, resourceType: { __typename: 'ResourceType', id: ID, name: string, processData: { __typename: 'ResourceTypeData', fields: Array<{ __typename: 'ResourceTypeField', name: string }> }, sinkData: { __typename: 'ResourceTypeData', fields: Array<{ __typename: 'ResourceTypeField', name: string }> }, sourceData: { __typename: 'ResourceTypeData', fields: Array<{ __typename: 'ResourceTypeField', name: string }> }, runData: { __typename: 'ResourceTypeData', fields: Array<{ __typename: 'ResourceTypeField', name: string }> } }, runUsage?: { __typename: 'RunUsage', id: ID } | null, timelineUsage?: { __typename: 'TimelineUsage', id: ID, startTime: Date, endTime: Date, resourceId: ID, resource: { __typename: 'Resource', id: ID, name: string, allowProcesses: boolean } } | null, inputs: Array<{ __typename: 'Process', id: ID, title: string, colorway: Colorway } | { __typename: 'Run', id: ID, title: string, colorway: Colorway } | { __typename: 'Sink', id: ID, title: string, colorway: Colorway } | { __typename: 'Source', id: ID, title: string, colorway: Colorway }>, outputs: Array<{ __typename: 'Process', id: ID, title: string, colorway: Colorway } | { __typename: 'Run', id: ID, title: string, colorway: Colorway } | { __typename: 'Sink', id: ID, title: string, colorway: Colorway } | { __typename: 'Source', id: ID, title: string, colorway: Colorway }> } | { __typename: 'Run', duration: Seconds, lag?: Seconds | null, id: ID, key: string, externalId?: string | null, title: string, subtitle: string, description: string, colorway: Colorway, locked: boolean, conflictCount: number, resourceType: { __typename: 'ResourceType', id: ID, name: string, processData: { __typename: 'ResourceTypeData', fields: Array<{ __typename: 'ResourceTypeField', name: string }> }, sinkData: { __typename: 'ResourceTypeData', fields: Array<{ __typename: 'ResourceTypeField', name: string }> }, sourceData: { __typename: 'ResourceTypeData', fields: Array<{ __typename: 'ResourceTypeField', name: string }> }, runData: { __typename: 'ResourceTypeData', fields: Array<{ __typename: 'ResourceTypeField', name: string }> } }, runUsages: Array<{ __typename: 'RunUsage', id: ID, process: { __typename: 'Process', id: ID, title: string, colorway: Colorway, taskIconId?: ID | null } }>, timelineUsage?: { __typename: 'TimelineUsage', id: ID, startTime: Date, endTime: Date, resourceId: ID, resource: { __typename: 'Resource', id: ID, name: string, allowProcesses: boolean } } | null, inputs: Array<{ __typename: 'Process', id: ID, title: string, colorway: Colorway } | { __typename: 'Run', id: ID, title: string, colorway: Colorway } | { __typename: 'Sink', id: ID, title: string, colorway: Colorway } | { __typename: 'Source', id: ID, title: string, colorway: Colorway }>, outputs: Array<{ __typename: 'Process', id: ID, title: string, colorway: Colorway } | { __typename: 'Run', id: ID, title: string, colorway: Colorway } | { __typename: 'Sink', id: ID, title: string, colorway: Colorway } | { __typename: 'Source', id: ID, title: string, colorway: Colorway }> } | { __typename: 'Sink', lag?: Seconds | null, id: ID, key: string, externalId?: string | null, title: string, subtitle: string, description: string, colorway: Colorway, locked: boolean, conflictCount: number, resourceType: { __typename: 'ResourceType', id: ID, name: string, processData: { __typename: 'ResourceTypeData', fields: Array<{ __typename: 'ResourceTypeField', name: string }> }, sinkData: { __typename: 'ResourceTypeData', fields: Array<{ __typename: 'ResourceTypeField', name: string }> }, sourceData: { __typename: 'ResourceTypeData', fields: Array<{ __typename: 'ResourceTypeField', name: string }> }, runData: { __typename: 'ResourceTypeData', fields: Array<{ __typename: 'ResourceTypeField', name: string }> } }, timelineUsage?: { __typename: 'TimelineUsage', id: ID, startTime: Date, endTime: Date, resourceId: ID, resource: { __typename: 'Resource', id: ID, name: string, allowProcesses: boolean } } | null, inputs: Array<{ __typename: 'Process', id: ID, title: string, colorway: Colorway } | { __typename: 'Run', id: ID, title: string, colorway: Colorway } | { __typename: 'Sink', id: ID, title: string, colorway: Colorway } | { __typename: 'Source', id: ID, title: string, colorway: Colorway }>, outputs: Array<{ __typename: 'Process', id: ID, title: string, colorway: Colorway } | { __typename: 'Run', id: ID, title: string, colorway: Colorway } | { __typename: 'Sink', id: ID, title: string, colorway: Colorway } | { __typename: 'Source', id: ID, title: string, colorway: Colorway }> } | { __typename: 'Source', id: ID, key: string, externalId?: string | null, title: string, subtitle: string, description: string, colorway: Colorway, locked: boolean, conflictCount: number, resourceType: { __typename: 'ResourceType', id: ID, name: string, processData: { __typename: 'ResourceTypeData', fields: Array<{ __typename: 'ResourceTypeField', name: string }> }, sinkData: { __typename: 'ResourceTypeData', fields: Array<{ __typename: 'ResourceTypeField', name: string }> }, sourceData: { __typename: 'ResourceTypeData', fields: Array<{ __typename: 'ResourceTypeField', name: string }> }, runData: { __typename: 'ResourceTypeData', fields: Array<{ __typename: 'ResourceTypeField', name: string }> } }, timelineUsage?: { __typename: 'TimelineUsage', id: ID, startTime: Date, endTime: Date, resourceId: ID, resource: { __typename: 'Resource', id: ID, name: string, allowProcesses: boolean } } | null, inputs: Array<{ __typename: 'Process', id: ID, title: string, colorway: Colorway } | { __typename: 'Run', id: ID, title: string, colorway: Colorway } | { __typename: 'Sink', id: ID, title: string, colorway: Colorway } | { __typename: 'Source', id: ID, title: string, colorway: Colorway }>, outputs: Array<{ __typename: 'Process', id: ID, title: string, colorway: Colorway } | { __typename: 'Run', id: ID, title: string, colorway: Colorway } | { __typename: 'Sink', id: ID, title: string, colorway: Colorway } | { __typename: 'Source', id: ID, title: string, colorway: Colorway }> } | null };

type ItemData_Process_Fragment = { __typename: 'Process', duration: Seconds, lag?: Seconds | null, taskIconId?: ID | null, inventoryEntityId?: ID | null, id: ID, key: string, externalId?: string | null, title: string, subtitle: string, description: string, colorway: Colorway, locked: boolean, conflictCount: number, runUsage?: { __typename: 'RunUsage', id: ID } | null, timelineUsage?: { __typename: 'TimelineUsage', id: ID, startTime: Date, endTime: Date, resourceId: ID, resource: { __typename: 'Resource', id: ID, name: string, allowProcesses: boolean } } | null, inputs: Array<{ __typename: 'Process', id: ID, title: string, colorway: Colorway } | { __typename: 'Run', id: ID, title: string, colorway: Colorway } | { __typename: 'Sink', id: ID, title: string, colorway: Colorway } | { __typename: 'Source', id: ID, title: string, colorway: Colorway }>, outputs: Array<{ __typename: 'Process', id: ID, title: string, colorway: Colorway } | { __typename: 'Run', id: ID, title: string, colorway: Colorway } | { __typename: 'Sink', id: ID, title: string, colorway: Colorway } | { __typename: 'Source', id: ID, title: string, colorway: Colorway }> };

type ItemData_Run_Fragment = { __typename: 'Run', duration: Seconds, lag?: Seconds | null, id: ID, key: string, externalId?: string | null, title: string, subtitle: string, description: string, colorway: Colorway, locked: boolean, conflictCount: number, runUsages: Array<{ __typename: 'RunUsage', id: ID, process: { __typename: 'Process', id: ID, title: string, colorway: Colorway, taskIconId?: ID | null } }>, timelineUsage?: { __typename: 'TimelineUsage', id: ID, startTime: Date, endTime: Date, resourceId: ID, resource: { __typename: 'Resource', id: ID, name: string, allowProcesses: boolean } } | null, inputs: Array<{ __typename: 'Process', id: ID, title: string, colorway: Colorway } | { __typename: 'Run', id: ID, title: string, colorway: Colorway } | { __typename: 'Sink', id: ID, title: string, colorway: Colorway } | { __typename: 'Source', id: ID, title: string, colorway: Colorway }>, outputs: Array<{ __typename: 'Process', id: ID, title: string, colorway: Colorway } | { __typename: 'Run', id: ID, title: string, colorway: Colorway } | { __typename: 'Sink', id: ID, title: string, colorway: Colorway } | { __typename: 'Source', id: ID, title: string, colorway: Colorway }> };

type ItemData_Sink_Fragment = { __typename: 'Sink', lag?: Seconds | null, id: ID, key: string, externalId?: string | null, title: string, subtitle: string, description: string, colorway: Colorway, locked: boolean, conflictCount: number, timelineUsage?: { __typename: 'TimelineUsage', id: ID, startTime: Date, endTime: Date, resourceId: ID, resource: { __typename: 'Resource', id: ID, name: string, allowProcesses: boolean } } | null, inputs: Array<{ __typename: 'Process', id: ID, title: string, colorway: Colorway } | { __typename: 'Run', id: ID, title: string, colorway: Colorway } | { __typename: 'Sink', id: ID, title: string, colorway: Colorway } | { __typename: 'Source', id: ID, title: string, colorway: Colorway }>, outputs: Array<{ __typename: 'Process', id: ID, title: string, colorway: Colorway } | { __typename: 'Run', id: ID, title: string, colorway: Colorway } | { __typename: 'Sink', id: ID, title: string, colorway: Colorway } | { __typename: 'Source', id: ID, title: string, colorway: Colorway }> };

type ItemData_Source_Fragment = { __typename: 'Source', id: ID, key: string, externalId?: string | null, title: string, subtitle: string, description: string, colorway: Colorway, locked: boolean, conflictCount: number, timelineUsage?: { __typename: 'TimelineUsage', id: ID, startTime: Date, endTime: Date, resourceId: ID, resource: { __typename: 'Resource', id: ID, name: string, allowProcesses: boolean } } | null, inputs: Array<{ __typename: 'Process', id: ID, title: string, colorway: Colorway } | { __typename: 'Run', id: ID, title: string, colorway: Colorway } | { __typename: 'Sink', id: ID, title: string, colorway: Colorway } | { __typename: 'Source', id: ID, title: string, colorway: Colorway }>, outputs: Array<{ __typename: 'Process', id: ID, title: string, colorway: Colorway } | { __typename: 'Run', id: ID, title: string, colorway: Colorway } | { __typename: 'Sink', id: ID, title: string, colorway: Colorway } | { __typename: 'Source', id: ID, title: string, colorway: Colorway }> };

export type ItemDataFragment = ItemData_Process_Fragment | ItemData_Run_Fragment | ItemData_Sink_Fragment | ItemData_Source_Fragment;

export type SetProcessTaskIconMutationVariables = Exact<{
  input: SetProcessTaskIconCommandInput;
}>;


export type SetProcessTaskIconMutation = { __typename: 'Mutation', setProcessTaskIcon: boolean };

export type SetItemDescriptionMutationVariables = Exact<{
  input: SetItemDescriptionCommandInput;
}>;


export type SetItemDescriptionMutation = { __typename: 'Mutation', setItemDescription: boolean };

export type SetItemLagMutationVariables = Exact<{
  input: SetItemLagCommandInput;
}>;


export type SetItemLagMutation = { __typename: 'Mutation', setItemLag: boolean };

export type ExtendItemUsingDurationCommandMutationVariables = Exact<{
  input: ExtendItemUsingDurationCommandInput;
}>;


export type ExtendItemUsingDurationCommandMutation = { __typename: 'Mutation', extendItemUsingDuration: boolean };

export type GetItemFieldsQueryVariables = Exact<{
  itemId: Scalars['ID'];
}>;


export type GetItemFieldsQuery = { __typename: 'Query', item?: { __typename: 'Process', id: ID, customFields: Array<{ __typename: 'CustomField', id: ID, name: string, value: string }> } | { __typename: 'Run', id: ID, customFields: Array<{ __typename: 'CustomField', id: ID, name: string, value: string }> } | { __typename: 'Sink', id: ID, customFields: Array<{ __typename: 'CustomField', id: ID, name: string, value: string }> } | { __typename: 'Source', id: ID, customFields: Array<{ __typename: 'CustomField', id: ID, name: string, value: string }> } | null };

export type SetItemCustomFieldMutationVariables = Exact<{
  input: SetItemCustomFieldCommandInput;
}>;


export type SetItemCustomFieldMutation = { __typename: 'Mutation', setItemCustomField: boolean };

export type SetItemColorwayMutationVariables = Exact<{
  input: SetItemColorwayCommandInput;
}>;


export type SetItemColorwayMutation = { __typename: 'Mutation', setItemColorway: boolean };

export type UpdateItemLocalFieldsQueryVariables = Exact<{
  itemId: Scalars['ID'];
}>;


export type UpdateItemLocalFieldsQuery = { __typename: 'Query', item?: { __typename: 'Process', id: ID, title: string, subtitle: string, customFields: Array<{ __typename: 'CustomField', id: ID, name: string, value: string }> } | { __typename: 'Run', id: ID, title: string, subtitle: string, customFields: Array<{ __typename: 'CustomField', id: ID, name: string, value: string }> } | { __typename: 'Sink', id: ID, title: string, subtitle: string, customFields: Array<{ __typename: 'CustomField', id: ID, name: string, value: string }> } | { __typename: 'Source', id: ID, title: string, subtitle: string, customFields: Array<{ __typename: 'CustomField', id: ID, name: string, value: string }> } | null };

export type SetItemLockedMutationVariables = Exact<{
  input: SetItemLockedCommandInput;
}>;


export type SetItemLockedMutation = { __typename: 'Mutation', setItemLocked: boolean };

export type CloneItemMutationVariables = Exact<{
  input: CloneItemCommandInput;
}>;


export type CloneItemMutation = { __typename: 'Mutation', cloneItem: boolean };

export type DeleteItemMutationVariables = Exact<{
  input: DeleteItemCommandInput;
}>;


export type DeleteItemMutation = { __typename: 'Mutation', deleteItem: { __typename: 'DeleteItemPayload', success: boolean, message: string } };

export type RestoreItemMutationVariables = Exact<{
  input: RestoreItemCommandInput;
}>;


export type RestoreItemMutation = { __typename: 'Mutation', restoreItem: boolean };

export type MoveItemOnTimelineMutationVariables = Exact<{
  input: MoveItemOnTimelineCommandInput;
}>;


export type MoveItemOnTimelineMutation = { __typename: 'Mutation', moveItemOnTimeline: { __typename: 'MoveItemOnTimelinePayload', message: string, error?: { __typename: 'OptimisticConcurrencyError' } | null } };

export type MoveItemsOnTimelineMutationVariables = Exact<{
  input: MoveItemsOnTimelineCommandInput;
}>;


export type MoveItemsOnTimelineMutation = { __typename: 'Mutation', moveItemsOnTimeline: { __typename: 'MoveItemsOnTimelinePayload', message: string, error?: { __typename: 'OptimisticConcurrencyError' } | null } };

export type MoveItemToClipboardMutationVariables = Exact<{
  input: MoveItemToClipboardCommandInput;
}>;


export type MoveItemToClipboardMutation = { __typename: 'Mutation', moveItemToClipboard: boolean };

export type MoveProcessInRunMutationVariables = Exact<{
  input: MoveProcessInRunCommandInput;
}>;


export type MoveProcessInRunMutation = { __typename: 'Mutation', moveProcessInRun: boolean };

export type CreateProcessMutationVariables = Exact<{
  input: CreateProcessCommandInput;
}>;


export type CreateProcessMutation = { __typename: 'Mutation', result: { __typename: 'CreateProcessPayload', item: { __typename: 'Process', id: ID } } };

export type CreateRunMutationVariables = Exact<{
  input: CreateRunCommandInput;
}>;


export type CreateRunMutation = { __typename: 'Mutation', result: { __typename: 'CreateRunPayload', item: { __typename: 'Run', id: ID } } };

export type CreateSourceMutationVariables = Exact<{
  input: CreateSourceCommandInput;
}>;


export type CreateSourceMutation = { __typename: 'Mutation', result: { __typename: 'CreateSourcePayload', item: { __typename: 'Source', id: ID } } };

export type CreateSinkMutationVariables = Exact<{
  input: CreateSinkCommandInput;
}>;


export type CreateSinkMutation = { __typename: 'Mutation', result: { __typename: 'CreateSinkPayload', item: { __typename: 'Sink', id: ID } } };

export type LocateItemQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type LocateItemQuery = { __typename: 'Query', item?: { __typename: 'Process', id: ID, timelineUsage?: { __typename: 'TimelineUsage', startTime: Date, endTime: Date } | null } | { __typename: 'Run', id: ID, timelineUsage?: { __typename: 'TimelineUsage', startTime: Date, endTime: Date } | null } | { __typename: 'Sink', id: ID, timelineUsage?: { __typename: 'TimelineUsage', startTime: Date, endTime: Date } | null } | { __typename: 'Source', id: ID, timelineUsage?: { __typename: 'TimelineUsage', startTime: Date, endTime: Date } | null } | null };

export type RunLockedQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type RunLockedQuery = { __typename: 'Query', item?: { __typename: 'Process', id: ID } | { __typename: 'Run', locked: boolean, id: ID } | { __typename: 'Sink', id: ID } | { __typename: 'Source', id: ID } | null };

export type ResizeItemOnTimelineMutationVariables = Exact<{
  input: ResizeItemOnTimelineCommandInput;
}>;


export type ResizeItemOnTimelineMutation = { __typename: 'Mutation', resizeItemOnTimeline: boolean };

export type ResourceNameQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type ResourceNameQuery = { __typename: 'Query', resource: { __typename: 'Resource', id: ID, name: string } };

export type SimpleResourceListQueryVariables = Exact<{ [key: string]: never; }>;


export type SimpleResourceListQuery = { __typename: 'Query', resources: Array<{ __typename: 'Resource', id: ID, name: string, displayIndex: number }> };

export type ListResourceSettingsQueryVariables = Exact<{ [key: string]: never; }>;


export type ListResourceSettingsQuery = { __typename: 'Query', resources: Array<{ __typename: 'Resource', id: ID, name: string, displayIndex: number, allowProcesses: boolean, allowSources: boolean, allowSinks: boolean, allowRuns: boolean, allowReservations: boolean }> };

export type ResourceSettingsQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type ResourceSettingsQuery = { __typename: 'Query', resource: { __typename: 'Resource', id: ID, name: string, displayIndex: number, allowProcesses: boolean, allowSources: boolean, allowSinks: boolean, allowRuns: boolean, allowReservations: boolean, allowOverlappingItems: boolean, salesOrderLane: boolean, resourceType: { __typename: 'ResourceType', id: ID }, defaultSchedule: Array<{ __typename: 'ResourceScheduleRange', startTime: Date, endTime: Date }> } };

export type ResourceScheduleQueryVariables = Exact<{
  id: Scalars['ID'];
  from: Scalars['DateTime'];
  to: Scalars['DateTime'];
}>;


export type ResourceScheduleQuery = { __typename: 'Query', resource: { __typename: 'Resource', id: ID, name: string, schedule: Array<{ __typename: 'ResourceScheduleRange', startTime: Date, endTime: Date }> } };

export type RenameResourceMutationVariables = Exact<{
  input: RenameResourceCommandInput;
}>;


export type RenameResourceMutation = { __typename: 'Mutation', renameResource: boolean };

export type ReorderResourcesMutationVariables = Exact<{
  input: ReorderResourcesCommandInput;
}>;


export type ReorderResourcesMutation = { __typename: 'Mutation', reorderResources: boolean };

export type SetResourceItemTypesAllowedMutationVariables = Exact<{
  input: SetResourceItemTypesAllowedCommandInput;
}>;


export type SetResourceItemTypesAllowedMutation = { __typename: 'Mutation', setResourceItemTypesAllowed: boolean };

export type SetResourceOverlapsAllowedMutationVariables = Exact<{
  input: SetResourceOverlapsAllowedCommandInput;
}>;


export type SetResourceOverlapsAllowedMutation = { __typename: 'Mutation', setResourceOverlapsAllowed: boolean };

export type SetResourceSalesOrderLaneMutationVariables = Exact<{
  input: SetResourceSalesOrderLaneCommandInput;
}>;


export type SetResourceSalesOrderLaneMutation = { __typename: 'Mutation', setResourceSalesOrderLane: boolean };

export type SalesOrderSyncStatusQueryVariables = Exact<{ [key: string]: never; }>;


export type SalesOrderSyncStatusQuery = { __typename: 'Query', salesOrderSyncStatus: { __typename: 'SalesOrderSyncStatus', lastRunAt?: Date | null, lastError?: string | null, rowCount: number, watermark?: string | null } };

export type SyncSalesOrdersNowMutationVariables = Exact<{ [key: string]: never; }>;


export type SyncSalesOrdersNowMutation = { __typename: 'Mutation', syncSalesOrdersNow: boolean };

export type CreateResourceMutationVariables = Exact<{
  input: CreateResourceCommandInput;
}>;


export type CreateResourceMutation = { __typename: 'Mutation', createResource: boolean };

export type DeleteResourceMutationVariables = Exact<{
  input: DeleteResourceCommandInput;
}>;


export type DeleteResourceMutation = { __typename: 'Mutation', deleteResource: boolean };

export type ResourceTypesQueryVariables = Exact<{ [key: string]: never; }>;


export type ResourceTypesQuery = { __typename: 'Query', resourceTypes: Array<{ __typename: 'ResourceType', id: ID, name: string }> };

export type SetResourceResourceTypeMutationVariables = Exact<{
  input: SetResourceResourceTypeCommandInput;
}>;


export type SetResourceResourceTypeMutation = { __typename: 'Mutation', setResourceResourceType: boolean };

export type SetDefaultResourceScheduleMutationVariables = Exact<{
  input: SetDefaultResourceScheduleCommandInput;
}>;


export type SetDefaultResourceScheduleMutation = { __typename: 'Mutation', setDefaultResourceSchedule: boolean };

export type SetResourceScheduleMutationVariables = Exact<{
  input: SetResourceScheduleCommandInput;
}>;


export type SetResourceScheduleMutation = { __typename: 'Mutation', setResourceSchedule: boolean };

export type ResourceFilterQueryVariables = Exact<{ [key: string]: never; }>;


export type ResourceFilterQuery = { __typename: 'Query', resources: Array<{ __typename: 'Resource', id: ID, name: string, displayIndex: number }>, myResourceFilter: { __typename: 'ResourceFilter', id: ID, items: Array<{ __typename: 'ResourceFilterItem', id: ID, resource: { __typename: 'Resource', id: ID } }> } };

export type FilterResourceMutationVariables = Exact<{
  input: FilterResourceCommandInput;
}>;


export type FilterResourceMutation = { __typename: 'Mutation', filterResource: boolean };

export type TimelineResourcesQueryVariables = Exact<{
  startTime: Scalars['DateTime'];
  endTime: Scalars['DateTime'];
}>;


export type TimelineResourcesQuery = { __typename: 'Query', resources: Array<{ __typename: 'Resource', id: ID, name: string, displayIndex: number, allowProcesses: boolean, allowSources: boolean, allowSinks: boolean, allowRuns: boolean, inventoryWorkstationId?: ID | null, allowOverlappingItems: boolean, salesOrderLane: boolean, resourceType: { __typename: 'ResourceType', id: ID }, items: Array<{ __typename: 'Process', duration: Seconds, lag?: Seconds | null, taskIconId?: ID | null, inventoryWorkstationId?: ID | null, id: ID, externalId?: string | null, title: string, subtitle: string, conflictCount: number, lastPositioned?: Date | null, colorway: Colorway, locked: boolean, runUsage?: { __typename: 'RunUsage', id: ID } | null, timelineUsage?: { __typename: 'TimelineUsage', id: ID, startTime: Date, endTime: Date, resourceId: ID } | null } | { __typename: 'Run', duration: Seconds, lag?: Seconds | null, id: ID, externalId?: string | null, title: string, subtitle: string, conflictCount: number, lastPositioned?: Date | null, colorway: Colorway, locked: boolean, runUsages: Array<{ __typename: 'RunUsage', id: ID, offset: Seconds, process: { __typename: 'Process', id: ID, title: string, subtitle: string, colorway: Colorway, lastPositioned?: Date | null, conflictCount: number, duration: Seconds, lag?: Seconds | null, taskIconId?: ID | null, inventoryWorkstationId?: ID | null, timelineUsage?: { __typename: 'TimelineUsage', id: ID, startTime: Date, endTime: Date, resourceId: ID } | null } }>, timelineUsage?: { __typename: 'TimelineUsage', id: ID, startTime: Date, endTime: Date, resourceId: ID } | null } | { __typename: 'Sink', lag?: Seconds | null, id: ID, externalId?: string | null, title: string, subtitle: string, conflictCount: number, lastPositioned?: Date | null, colorway: Colorway, locked: boolean, timelineUsage?: { __typename: 'TimelineUsage', id: ID, startTime: Date, endTime: Date, resourceId: ID } | null } | { __typename: 'Source', id: ID, externalId?: string | null, title: string, subtitle: string, conflictCount: number, lastPositioned?: Date | null, colorway: Colorway, locked: boolean, timelineUsage?: { __typename: 'TimelineUsage', id: ID, startTime: Date, endTime: Date, resourceId: ID } | null }>, schedule: Array<{ __typename: 'ResourceScheduleRange', startTime: Date, endTime: Date }> }> };

type ResourceItemData_Process_Fragment = { __typename: 'Process', duration: Seconds, lag?: Seconds | null, taskIconId?: ID | null, inventoryWorkstationId?: ID | null, id: ID, externalId?: string | null, title: string, subtitle: string, conflictCount: number, lastPositioned?: Date | null, colorway: Colorway, locked: boolean, runUsage?: { __typename: 'RunUsage', id: ID } | null, timelineUsage?: { __typename: 'TimelineUsage', id: ID, startTime: Date, endTime: Date, resourceId: ID } | null };

type ResourceItemData_Run_Fragment = { __typename: 'Run', duration: Seconds, lag?: Seconds | null, id: ID, externalId?: string | null, title: string, subtitle: string, conflictCount: number, lastPositioned?: Date | null, colorway: Colorway, locked: boolean, runUsages: Array<{ __typename: 'RunUsage', id: ID, offset: Seconds, process: { __typename: 'Process', id: ID, title: string, subtitle: string, colorway: Colorway, lastPositioned?: Date | null, conflictCount: number, duration: Seconds, lag?: Seconds | null, taskIconId?: ID | null, inventoryWorkstationId?: ID | null, timelineUsage?: { __typename: 'TimelineUsage', id: ID, startTime: Date, endTime: Date, resourceId: ID } | null } }>, timelineUsage?: { __typename: 'TimelineUsage', id: ID, startTime: Date, endTime: Date, resourceId: ID } | null };

type ResourceItemData_Sink_Fragment = { __typename: 'Sink', lag?: Seconds | null, id: ID, externalId?: string | null, title: string, subtitle: string, conflictCount: number, lastPositioned?: Date | null, colorway: Colorway, locked: boolean, timelineUsage?: { __typename: 'TimelineUsage', id: ID, startTime: Date, endTime: Date, resourceId: ID } | null };

type ResourceItemData_Source_Fragment = { __typename: 'Source', id: ID, externalId?: string | null, title: string, subtitle: string, conflictCount: number, lastPositioned?: Date | null, colorway: Colorway, locked: boolean, timelineUsage?: { __typename: 'TimelineUsage', id: ID, startTime: Date, endTime: Date, resourceId: ID } | null };

export type ResourceItemDataFragment = ResourceItemData_Process_Fragment | ResourceItemData_Run_Fragment | ResourceItemData_Sink_Fragment | ResourceItemData_Source_Fragment;

type CommonItemFields_Process_Fragment = { __typename: 'Process', id: ID, externalId?: string | null, title: string, subtitle: string, conflictCount: number, lastPositioned?: Date | null, colorway: Colorway, locked: boolean, timelineUsage?: { __typename: 'TimelineUsage', id: ID, startTime: Date, endTime: Date, resourceId: ID } | null };

type CommonItemFields_Run_Fragment = { __typename: 'Run', id: ID, externalId?: string | null, title: string, subtitle: string, conflictCount: number, lastPositioned?: Date | null, colorway: Colorway, locked: boolean, timelineUsage?: { __typename: 'TimelineUsage', id: ID, startTime: Date, endTime: Date, resourceId: ID } | null };

type CommonItemFields_Sink_Fragment = { __typename: 'Sink', id: ID, externalId?: string | null, title: string, subtitle: string, conflictCount: number, lastPositioned?: Date | null, colorway: Colorway, locked: boolean, timelineUsage?: { __typename: 'TimelineUsage', id: ID, startTime: Date, endTime: Date, resourceId: ID } | null };

type CommonItemFields_Source_Fragment = { __typename: 'Source', id: ID, externalId?: string | null, title: string, subtitle: string, conflictCount: number, lastPositioned?: Date | null, colorway: Colorway, locked: boolean, timelineUsage?: { __typename: 'TimelineUsage', id: ID, startTime: Date, endTime: Date, resourceId: ID } | null };

export type CommonItemFieldsFragment = CommonItemFields_Process_Fragment | CommonItemFields_Run_Fragment | CommonItemFields_Sink_Fragment | CommonItemFields_Source_Fragment;

export type ResourceChangedSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type ResourceChangedSubscription = { __typename: 'Subscription', resourceChanged: { __typename: 'ResourcesWrapper', resources: Array<{ __typename: 'Resource', id: ID, name: string, displayIndex: number, allowProcesses: boolean, allowSources: boolean, allowSinks: boolean, allowRuns: boolean, allowOverlappingItems: boolean, salesOrderLane: boolean, resourceType: { __typename: 'ResourceType', id: ID } }> } };

export type RunEditorQueryVariables = Exact<{
  runId: Scalars['ID'];
}>;


export type RunEditorQuery = { __typename: 'Query', item?: { __typename: 'Process', id: ID, locked: boolean, runUsage?: { __typename: 'RunUsage', id: ID, runId: ID } | null } | { __typename: 'Run', duration: Seconds, id: ID, locked: boolean, timelineUsage?: { __typename: 'TimelineUsage', id: ID, resource: { __typename: 'Resource', id: ID, allowProcesses: boolean } } | null, resourceType: { __typename: 'ResourceType', id: ID, name: string, processData: { __typename: 'ResourceTypeData', fields: Array<{ __typename: 'ResourceTypeField', name: string }> } }, runUsages: Array<{ __typename: 'RunUsage', id: ID, offset: Seconds, process: { __typename: 'Process', id: ID, title: string, locked: boolean, subtitle: string, colorway: Colorway, conflictCount: number, description: string, duration: Seconds, lag?: Seconds | null, taskIconId?: ID | null, timelineUsage?: { __typename: 'TimelineUsage', id: ID, startTime: Date, endTime: Date, resourceId: ID } | null, inputs: Array<{ __typename: 'Process', id: ID, title: string, colorway: Colorway } | { __typename: 'Run', id: ID, title: string, colorway: Colorway } | { __typename: 'Sink', id: ID, title: string, colorway: Colorway } | { __typename: 'Source', id: ID, title: string, colorway: Colorway }>, outputs: Array<{ __typename: 'Process', id: ID, title: string, colorway: Colorway } | { __typename: 'Run', id: ID, title: string, colorway: Colorway } | { __typename: 'Sink', id: ID, title: string, colorway: Colorway } | { __typename: 'Source', id: ID, title: string, colorway: Colorway }> } }> } | { __typename: 'Sink', id: ID, locked: boolean } | { __typename: 'Source', id: ID, locked: boolean } | null };

export type SearchQueryVariables = Exact<{
  searchQuery: Scalars['String'];
  take: Scalars['Int'];
  months: Scalars['Int'];
}>;


export type SearchQuery = { __typename: 'Query', searchItems: { __typename: 'SearchItemsResult', items: Array<{ __typename: 'SearchItemsResultItem', item: { __typename: 'Process', id: ID, title: string, colorway: Colorway, timelineUsage?: { __typename: 'TimelineUsage', id: ID, startTime: Date, resource: { __typename: 'Resource', id: ID, name: string } } | null } | { __typename: 'Run', id: ID, title: string, colorway: Colorway, timelineUsage?: { __typename: 'TimelineUsage', id: ID, startTime: Date, resource: { __typename: 'Resource', id: ID, name: string } } | null } | { __typename: 'Sink', id: ID, title: string, colorway: Colorway, timelineUsage?: { __typename: 'TimelineUsage', id: ID, startTime: Date, resource: { __typename: 'Resource', id: ID, name: string } } | null } | { __typename: 'Source', id: ID, title: string, colorway: Colorway, timelineUsage?: { __typename: 'TimelineUsage', id: ID, startTime: Date, resource: { __typename: 'Resource', id: ID, name: string } } | null }, customField: { __typename: 'CustomField', name: string, value: string } }> } };

export type ItemCreatedSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type ItemCreatedSubscription = { __typename: 'Subscription', itemCreated: { __typename: 'ItemsWrapper', items: Array<{ __typename: 'Process', inventoryWorkstationId?: ID | null, duration: Seconds, lag?: Seconds | null, taskIconId?: ID | null, id: ID, externalId?: string | null, title: string, subtitle: string, conflictCount: number, lastPositioned?: Date | null, colorway: Colorway, locked: boolean, runUsage?: { __typename: 'RunUsage', id: ID, runId: ID, offset: Seconds } | null, timelineUsage?: { __typename: 'TimelineUsage', id: ID, startTime: Date, endTime: Date, resourceId: ID } | null } | { __typename: 'Run', duration: Seconds, lag?: Seconds | null, id: ID, externalId?: string | null, title: string, subtitle: string, conflictCount: number, lastPositioned?: Date | null, colorway: Colorway, locked: boolean, runUsages: Array<{ __typename: 'RunUsage', id: ID, offset: Seconds, process: { __typename: 'Process', id: ID, title: string, subtitle: string, colorway: Colorway, lastPositioned?: Date | null, conflictCount: number, duration: Seconds, lag?: Seconds | null, taskIconId?: ID | null, inventoryWorkstationId?: ID | null, timelineUsage?: { __typename: 'TimelineUsage', id: ID, startTime: Date, endTime: Date, resourceId: ID } | null } }>, timelineUsage?: { __typename: 'TimelineUsage', id: ID, startTime: Date, endTime: Date, resourceId: ID } | null } | { __typename: 'Sink', lag?: Seconds | null, id: ID, externalId?: string | null, title: string, subtitle: string, conflictCount: number, lastPositioned?: Date | null, colorway: Colorway, locked: boolean, timelineUsage?: { __typename: 'TimelineUsage', id: ID, startTime: Date, endTime: Date, resourceId: ID } | null } | { __typename: 'Source', id: ID, externalId?: string | null, title: string, subtitle: string, conflictCount: number, lastPositioned?: Date | null, colorway: Colorway, locked: boolean, timelineUsage?: { __typename: 'TimelineUsage', id: ID, startTime: Date, endTime: Date, resourceId: ID } | null }> } };

export type ItemDeletedSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type ItemDeletedSubscription = { __typename: 'Subscription', itemDeleted: { __typename: 'ItemsWrapper', items: Array<{ __typename: 'Process', id: ID } | { __typename: 'Run', id: ID } | { __typename: 'Sink', id: ID } | { __typename: 'Source', id: ID }> } };

export type ItemChangedSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type ItemChangedSubscription = { __typename: 'Subscription', itemDataChanged: { __typename: 'ItemsWrapper', items: Array<{ __typename: 'Process', taskIconId?: ID | null, lag?: Seconds | null, id: ID, colorway: Colorway, title: string, subtitle: string, description: string, locked: boolean, lastPositioned?: Date | null, customFields: Array<{ __typename: 'CustomField', id: ID, name: string, value: string }> } | { __typename: 'Run', lag?: Seconds | null, id: ID, colorway: Colorway, title: string, subtitle: string, description: string, locked: boolean, lastPositioned?: Date | null, customFields: Array<{ __typename: 'CustomField', id: ID, name: string, value: string }> } | { __typename: 'Sink', lag?: Seconds | null, id: ID, colorway: Colorway, title: string, subtitle: string, description: string, locked: boolean, lastPositioned?: Date | null, customFields: Array<{ __typename: 'CustomField', id: ID, name: string, value: string }> } | { __typename: 'Source', id: ID, colorway: Colorway, title: string, subtitle: string, description: string, locked: boolean, lastPositioned?: Date | null, customFields: Array<{ __typename: 'CustomField', id: ID, name: string, value: string }> }> } };

export type ItemConflictStatusChangedSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type ItemConflictStatusChangedSubscription = { __typename: 'Subscription', itemConflictStatusChanged: { __typename: 'ItemsWrapper', items: Array<{ __typename: 'Process', id: ID, conflictCount: number } | { __typename: 'Run', id: ID, conflictCount: number } | { __typename: 'Sink', id: ID, conflictCount: number } | { __typename: 'Source', id: ID, conflictCount: number }> } };

export type ItemMovedSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type ItemMovedSubscription = { __typename: 'Subscription', itemMoved: { __typename: 'ItemsWrapper', items: Array<{ __typename: 'Process', duration: Seconds, lag?: Seconds | null, id: ID, locked: boolean, lastPositioned?: Date | null, conflictCount: number, runUsage?: { __typename: 'RunUsage', id: ID, offset: Seconds, runId: ID } | null, timelineUsage?: { __typename: 'TimelineUsage', id: ID, startTime: Date, endTime: Date, resourceId: ID } | null } | { __typename: 'Run', duration: Seconds, lag?: Seconds | null, id: ID, locked: boolean, lastPositioned?: Date | null, conflictCount: number, timelineUsage?: { __typename: 'TimelineUsage', id: ID, startTime: Date, endTime: Date, resourceId: ID } | null } | { __typename: 'Sink', id: ID, locked: boolean, lastPositioned?: Date | null, conflictCount: number, timelineUsage?: { __typename: 'TimelineUsage', id: ID, startTime: Date, endTime: Date, resourceId: ID } | null } | { __typename: 'Source', id: ID, locked: boolean, lastPositioned?: Date | null, conflictCount: number, timelineUsage?: { __typename: 'TimelineUsage', id: ID, startTime: Date, endTime: Date, resourceId: ID } | null }> } };

export type ResourceCreatedSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type ResourceCreatedSubscription = { __typename: 'Subscription', resourceCreated: { __typename: 'ResourcesWrapper', resources: Array<{ __typename: 'Resource', id: ID, name: string, displayIndex: number, allowProcesses: boolean, allowSources: boolean, allowSinks: boolean, allowRuns: boolean, allowOverlappingItems: boolean, salesOrderLane: boolean, resourceType: { __typename: 'ResourceType', id: ID } }> } };

export type ResourceDeletedSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type ResourceDeletedSubscription = { __typename: 'Subscription', resourceDeleted: { __typename: 'ResourcesWrapper', resources: Array<{ __typename: 'Resource', id: ID }> } };

export type ResourceScheduleChangedSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type ResourceScheduleChangedSubscription = { __typename: 'Subscription', resourceScheduleChanged: { __typename: 'ResourcesWrapper', resources: Array<{ __typename: 'Resource', id: ID }> } };

export type CurrentUserQueryVariables = Exact<{ [key: string]: never; }>;


export type CurrentUserQuery = { __typename: 'Query', currentUser: { __typename: 'UserContext', name?: string | null, policies: Array<AuthorizationPolicy>, email?: string | null } };

export type GetWorkstationResourceRangeQueryVariables = Exact<{
  id: Scalars['ID'];
  startTime: Scalars['DateTime'];
  endTime: Scalars['DateTime'];
}>;


export type GetWorkstationResourceRangeQuery = { __typename: 'Query', resource: { __typename: 'Resource', id: ID, name: string, resourceType: { __typename: 'ResourceType', id: ID, processData: { __typename: 'ResourceTypeData', fields: Array<{ __typename: 'ResourceTypeField', name: string }> }, runData: { __typename: 'ResourceTypeData', fields: Array<{ __typename: 'ResourceTypeField', name: string }> } }, items: Array<{ __typename: 'Process', duration: Seconds, lag?: Seconds | null, taskIconId?: ID | null, inventoryEntityId?: ID | null, id: ID, title: string, subtitle: string, conflictCount: number, colorway: Colorway, description: string, runUsage?: { __typename: 'RunUsage', id: ID } | null, timelineUsage?: { __typename: 'TimelineUsage', id: ID, startTime: Date, endTime: Date } | null, customFields: Array<{ __typename: 'CustomField', id: ID, name: string, value: string }> } | { __typename: 'Run', duration: Seconds, lag?: Seconds | null, id: ID, title: string, subtitle: string, conflictCount: number, colorway: Colorway, description: string, runUsages: Array<{ __typename: 'RunUsage', id: ID, process: { __typename: 'Process', id: ID, title: string, subtitle: string, conflictCount: number, colorway: Colorway, description: string, duration: Seconds, lag?: Seconds | null, taskIconId?: ID | null, inventoryEntityId?: ID | null, timelineUsage?: { __typename: 'TimelineUsage', id: ID, startTime: Date, endTime: Date } | null, customFields: Array<{ __typename: 'CustomField', id: ID, name: string, value: string }> } }>, timelineUsage?: { __typename: 'TimelineUsage', id: ID, startTime: Date, endTime: Date } | null, customFields: Array<{ __typename: 'CustomField', id: ID, name: string, value: string }> } | { __typename: 'Sink', id: ID, title: string, subtitle: string, conflictCount: number, colorway: Colorway, description: string, timelineUsage?: { __typename: 'TimelineUsage', id: ID, startTime: Date, endTime: Date } | null, customFields: Array<{ __typename: 'CustomField', id: ID, name: string, value: string }> } | { __typename: 'Source', id: ID, title: string, subtitle: string, conflictCount: number, colorway: Colorway, description: string, timelineUsage?: { __typename: 'TimelineUsage', id: ID, startTime: Date, endTime: Date } | null, customFields: Array<{ __typename: 'CustomField', id: ID, name: string, value: string }> }>, schedule: Array<{ __typename: 'ResourceScheduleRange', startTime: Date, endTime: Date }> } };

export const InputOutputFragmentDoc = gql`
    fragment InputOutput on Item {
  conflictCount
  ... on Process {
    inputs {
      id
      title
      colorway
      __typename
    }
    outputs {
      id
      title
      colorway
      __typename
    }
  }
  ... on Source {
    inputs {
      id
      title
      colorway
      __typename
    }
    outputs {
      id
      title
      colorway
      __typename
    }
  }
  ... on Sink {
    inputs {
      id
      title
      colorway
      __typename
    }
    outputs {
      id
      title
      colorway
      __typename
    }
  }
  ... on Run {
    inputs {
      id
      title
      colorway
      __typename
    }
    outputs {
      id
      title
      colorway
      __typename
    }
  }
}
    `;
export const ItemDataFragmentDoc = gql`
    fragment ItemData on Item {
  __typename
  id
  key
  externalId
  title
  subtitle
  description
  colorway
  locked
  timelineUsage {
    id
    startTime
    endTime
    resourceId
    resource {
      id
      name
      allowProcesses
    }
  }
  ... on Process {
    duration
    lag
    taskIconId
    inventoryEntityId
    runUsage {
      id
    }
  }
  ... on Run {
    duration
    lag
    runUsages {
      id
      process {
        id
        title
        colorway
        taskIconId
      }
    }
  }
  ... on Sink {
    lag
  }
  ...InputOutput
}
    ${InputOutputFragmentDoc}`;
export const CommonItemFieldsFragmentDoc = gql`
    fragment CommonItemFields on Item {
  __typename
  id
  externalId
  title
  subtitle
  conflictCount
  lastPositioned
  colorway
  locked
  timelineUsage {
    id
    startTime
    endTime
    resourceId
  }
}
    `;
export const ResourceItemDataFragmentDoc = gql`
    fragment ResourceItemData on Item {
  ...CommonItemFields
  ... on Process {
    duration
    lag
    taskIconId
    inventoryWorkstationId
    runUsage {
      id
    }
  }
  ... on Sink {
    lag
  }
  ... on Run {
    duration
    lag
    runUsages {
      id
      offset
      process {
        id
        title
        subtitle
        colorway
        lastPositioned
        conflictCount
        duration
        lag
        taskIconId
        inventoryWorkstationId
        timelineUsage {
          id
          startTime
          endTime
          resourceId
        }
      }
    }
  }
}
    ${CommonItemFieldsFragmentDoc}`;
export const GetChainDocument = gql`
    query GetChain($itemId: ID!) {
  fullChain(id: $itemId) {
    id
    sourceItemId
    targetItemId
  }
}
    `;

/**
 * __useGetChainQuery__
 *
 * To run a query within a React component, call `useGetChainQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetChainQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetChainQuery({
 *   variables: {
 *      itemId: // value for 'itemId'
 *   },
 * });
 */
export function useGetChainQuery(baseOptions: Apollo.QueryHookOptions<GetChainQuery, GetChainQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetChainQuery, GetChainQueryVariables>(GetChainDocument, options);
      }
export function useGetChainLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetChainQuery, GetChainQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetChainQuery, GetChainQueryVariables>(GetChainDocument, options);
        }
export type GetChainQueryHookResult = ReturnType<typeof useGetChainQuery>;
export type GetChainLazyQueryHookResult = ReturnType<typeof useGetChainLazyQuery>;
export type GetChainQueryResult = Apollo.QueryResult<GetChainQuery, GetChainQueryVariables>;
export const CreateChainDocument = gql`
    mutation CreateChain($input: CreateChainCommandInput!) {
  createChain(input: $input)
}
    `;
export type CreateChainMutationFn = Apollo.MutationFunction<CreateChainMutation, CreateChainMutationVariables>;

/**
 * __useCreateChainMutation__
 *
 * To run a mutation, you first call `useCreateChainMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateChainMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createChainMutation, { data, loading, error }] = useCreateChainMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateChainMutation(baseOptions?: Apollo.MutationHookOptions<CreateChainMutation, CreateChainMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateChainMutation, CreateChainMutationVariables>(CreateChainDocument, options);
      }
export type CreateChainMutationHookResult = ReturnType<typeof useCreateChainMutation>;
export type CreateChainMutationResult = Apollo.MutationResult<CreateChainMutation>;
export type CreateChainMutationOptions = Apollo.BaseMutationOptions<CreateChainMutation, CreateChainMutationVariables>;
export const DeleteChainDocument = gql`
    mutation DeleteChain($input: DeleteChainCommandInput!) {
  deleteChain(input: $input)
}
    `;
export type DeleteChainMutationFn = Apollo.MutationFunction<DeleteChainMutation, DeleteChainMutationVariables>;

/**
 * __useDeleteChainMutation__
 *
 * To run a mutation, you first call `useDeleteChainMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteChainMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteChainMutation, { data, loading, error }] = useDeleteChainMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteChainMutation(baseOptions?: Apollo.MutationHookOptions<DeleteChainMutation, DeleteChainMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteChainMutation, DeleteChainMutationVariables>(DeleteChainDocument, options);
      }
export type DeleteChainMutationHookResult = ReturnType<typeof useDeleteChainMutation>;
export type DeleteChainMutationResult = Apollo.MutationResult<DeleteChainMutation>;
export type DeleteChainMutationOptions = Apollo.BaseMutationOptions<DeleteChainMutation, DeleteChainMutationVariables>;
export const GetItemInputsDocument = gql`
    query GetItemInputs($id: ID!) {
  item(id: $id) {
    id
    ...InputOutput
  }
}
    ${InputOutputFragmentDoc}`;

/**
 * __useGetItemInputsQuery__
 *
 * To run a query within a React component, call `useGetItemInputsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetItemInputsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetItemInputsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetItemInputsQuery(baseOptions: Apollo.QueryHookOptions<GetItemInputsQuery, GetItemInputsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetItemInputsQuery, GetItemInputsQueryVariables>(GetItemInputsDocument, options);
      }
export function useGetItemInputsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetItemInputsQuery, GetItemInputsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetItemInputsQuery, GetItemInputsQueryVariables>(GetItemInputsDocument, options);
        }
export type GetItemInputsQueryHookResult = ReturnType<typeof useGetItemInputsQuery>;
export type GetItemInputsLazyQueryHookResult = ReturnType<typeof useGetItemInputsLazyQuery>;
export type GetItemInputsQueryResult = Apollo.QueryResult<GetItemInputsQuery, GetItemInputsQueryVariables>;
export const GetAdditionalItemDocument = gql`
    query GetAdditionalItem($id: ID!) {
  item(id: $id) {
    id
    timelineUsage {
      id
      startTime
      endTime
      resourceId
    }
    ... on Process {
      lag
    }
    ... on Run {
      lag
    }
  }
}
    `;

/**
 * __useGetAdditionalItemQuery__
 *
 * To run a query within a React component, call `useGetAdditionalItemQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAdditionalItemQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAdditionalItemQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetAdditionalItemQuery(baseOptions: Apollo.QueryHookOptions<GetAdditionalItemQuery, GetAdditionalItemQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAdditionalItemQuery, GetAdditionalItemQueryVariables>(GetAdditionalItemDocument, options);
      }
export function useGetAdditionalItemLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAdditionalItemQuery, GetAdditionalItemQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAdditionalItemQuery, GetAdditionalItemQueryVariables>(GetAdditionalItemDocument, options);
        }
export type GetAdditionalItemQueryHookResult = ReturnType<typeof useGetAdditionalItemQuery>;
export type GetAdditionalItemLazyQueryHookResult = ReturnType<typeof useGetAdditionalItemLazyQuery>;
export type GetAdditionalItemQueryResult = Apollo.QueryResult<GetAdditionalItemQuery, GetAdditionalItemQueryVariables>;
export const ChangesDocument = gql`
    query Changes($count: Int!, $itemId: ID) {
  changes(count: $count, itemId: $itemId) {
    id
    userName
    date
    changeType
    affectedItem {
      id
      title
      deleted
    }
    affectedResource {
      id
      name
    }
  }
}
    `;

/**
 * __useChangesQuery__
 *
 * To run a query within a React component, call `useChangesQuery` and pass it any options that fit your needs.
 * When your component renders, `useChangesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useChangesQuery({
 *   variables: {
 *      count: // value for 'count'
 *      itemId: // value for 'itemId'
 *   },
 * });
 */
export function useChangesQuery(baseOptions: Apollo.QueryHookOptions<ChangesQuery, ChangesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ChangesQuery, ChangesQueryVariables>(ChangesDocument, options);
      }
export function useChangesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ChangesQuery, ChangesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ChangesQuery, ChangesQueryVariables>(ChangesDocument, options);
        }
export type ChangesQueryHookResult = ReturnType<typeof useChangesQuery>;
export type ChangesLazyQueryHookResult = ReturnType<typeof useChangesLazyQuery>;
export type ChangesQueryResult = Apollo.QueryResult<ChangesQuery, ChangesQueryVariables>;
export const ClipboardDocument = gql`
    query Clipboard {
  clipboard {
    id
    items {
      id
      externalId
      title
      subtitle
      colorway
      locked
      ... on Process {
        taskIconId
        duration
        inventoryWorkstationId
      }
      ... on Run {
        duration
        runUsages {
          id
          offset
          process {
            id
            title
            lag
            duration
            colorway
            taskIconId
            inventoryWorkstationId
          }
        }
      }
      timelineUsage {
        id
        startTime
        endTime
        resourceId
      }
    }
    userEmail
  }
}
    `;

/**
 * __useClipboardQuery__
 *
 * To run a query within a React component, call `useClipboardQuery` and pass it any options that fit your needs.
 * When your component renders, `useClipboardQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useClipboardQuery({
 *   variables: {
 *   },
 * });
 */
export function useClipboardQuery(baseOptions?: Apollo.QueryHookOptions<ClipboardQuery, ClipboardQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ClipboardQuery, ClipboardQueryVariables>(ClipboardDocument, options);
      }
export function useClipboardLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ClipboardQuery, ClipboardQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ClipboardQuery, ClipboardQueryVariables>(ClipboardDocument, options);
        }
export type ClipboardQueryHookResult = ReturnType<typeof useClipboardQuery>;
export type ClipboardLazyQueryHookResult = ReturnType<typeof useClipboardLazyQuery>;
export type ClipboardQueryResult = Apollo.QueryResult<ClipboardQuery, ClipboardQueryVariables>;
export const ItemMovedToClipboardDocument = gql`
    subscription ItemMovedToClipboard {
  itemMovedToClipboard {
    items {
      ...ResourceItemData
    }
  }
}
    ${ResourceItemDataFragmentDoc}`;

/**
 * __useItemMovedToClipboardSubscription__
 *
 * To run a query within a React component, call `useItemMovedToClipboardSubscription` and pass it any options that fit your needs.
 * When your component renders, `useItemMovedToClipboardSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useItemMovedToClipboardSubscription({
 *   variables: {
 *   },
 * });
 */
export function useItemMovedToClipboardSubscription(baseOptions?: Apollo.SubscriptionHookOptions<ItemMovedToClipboardSubscription, ItemMovedToClipboardSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<ItemMovedToClipboardSubscription, ItemMovedToClipboardSubscriptionVariables>(ItemMovedToClipboardDocument, options);
      }
export type ItemMovedToClipboardSubscriptionHookResult = ReturnType<typeof useItemMovedToClipboardSubscription>;
export type ItemMovedToClipboardSubscriptionResult = Apollo.SubscriptionResult<ItemMovedToClipboardSubscription>;
export const ItemMovedFromClipboardDocument = gql`
    subscription ItemMovedFromClipboard {
  itemMovedFromClipboard {
    items {
      ...ResourceItemData
    }
  }
}
    ${ResourceItemDataFragmentDoc}`;

/**
 * __useItemMovedFromClipboardSubscription__
 *
 * To run a query within a React component, call `useItemMovedFromClipboardSubscription` and pass it any options that fit your needs.
 * When your component renders, `useItemMovedFromClipboardSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useItemMovedFromClipboardSubscription({
 *   variables: {
 *   },
 * });
 */
export function useItemMovedFromClipboardSubscription(baseOptions?: Apollo.SubscriptionHookOptions<ItemMovedFromClipboardSubscription, ItemMovedFromClipboardSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<ItemMovedFromClipboardSubscription, ItemMovedFromClipboardSubscriptionVariables>(ItemMovedFromClipboardDocument, options);
      }
export type ItemMovedFromClipboardSubscriptionHookResult = ReturnType<typeof useItemMovedFromClipboardSubscription>;
export type ItemMovedFromClipboardSubscriptionResult = Apollo.SubscriptionResult<ItemMovedFromClipboardSubscription>;
export const GetItemDocument = gql`
    query GetItem($id: ID!) {
  item(id: $id) {
    ...ItemData
    resourceType {
      id
      name
      processData {
        fields {
          name
        }
      }
      sinkData {
        fields {
          name
        }
      }
      sourceData {
        fields {
          name
        }
      }
      runData {
        fields {
          name
        }
      }
    }
  }
}
    ${ItemDataFragmentDoc}`;

/**
 * __useGetItemQuery__
 *
 * To run a query within a React component, call `useGetItemQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetItemQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetItemQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetItemQuery(baseOptions: Apollo.QueryHookOptions<GetItemQuery, GetItemQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetItemQuery, GetItemQueryVariables>(GetItemDocument, options);
      }
export function useGetItemLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetItemQuery, GetItemQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetItemQuery, GetItemQueryVariables>(GetItemDocument, options);
        }
export type GetItemQueryHookResult = ReturnType<typeof useGetItemQuery>;
export type GetItemLazyQueryHookResult = ReturnType<typeof useGetItemLazyQuery>;
export type GetItemQueryResult = Apollo.QueryResult<GetItemQuery, GetItemQueryVariables>;
export const SetProcessTaskIconDocument = gql`
    mutation SetProcessTaskIcon($input: SetProcessTaskIconCommandInput!) {
  setProcessTaskIcon(input: $input)
}
    `;
export type SetProcessTaskIconMutationFn = Apollo.MutationFunction<SetProcessTaskIconMutation, SetProcessTaskIconMutationVariables>;

/**
 * __useSetProcessTaskIconMutation__
 *
 * To run a mutation, you first call `useSetProcessTaskIconMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetProcessTaskIconMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setProcessTaskIconMutation, { data, loading, error }] = useSetProcessTaskIconMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSetProcessTaskIconMutation(baseOptions?: Apollo.MutationHookOptions<SetProcessTaskIconMutation, SetProcessTaskIconMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetProcessTaskIconMutation, SetProcessTaskIconMutationVariables>(SetProcessTaskIconDocument, options);
      }
export type SetProcessTaskIconMutationHookResult = ReturnType<typeof useSetProcessTaskIconMutation>;
export type SetProcessTaskIconMutationResult = Apollo.MutationResult<SetProcessTaskIconMutation>;
export type SetProcessTaskIconMutationOptions = Apollo.BaseMutationOptions<SetProcessTaskIconMutation, SetProcessTaskIconMutationVariables>;
export const SetItemDescriptionDocument = gql`
    mutation SetItemDescription($input: SetItemDescriptionCommandInput!) {
  setItemDescription(input: $input)
}
    `;
export type SetItemDescriptionMutationFn = Apollo.MutationFunction<SetItemDescriptionMutation, SetItemDescriptionMutationVariables>;

/**
 * __useSetItemDescriptionMutation__
 *
 * To run a mutation, you first call `useSetItemDescriptionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetItemDescriptionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setItemDescriptionMutation, { data, loading, error }] = useSetItemDescriptionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSetItemDescriptionMutation(baseOptions?: Apollo.MutationHookOptions<SetItemDescriptionMutation, SetItemDescriptionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetItemDescriptionMutation, SetItemDescriptionMutationVariables>(SetItemDescriptionDocument, options);
      }
export type SetItemDescriptionMutationHookResult = ReturnType<typeof useSetItemDescriptionMutation>;
export type SetItemDescriptionMutationResult = Apollo.MutationResult<SetItemDescriptionMutation>;
export type SetItemDescriptionMutationOptions = Apollo.BaseMutationOptions<SetItemDescriptionMutation, SetItemDescriptionMutationVariables>;
export const SetItemLagDocument = gql`
    mutation SetItemLag($input: SetItemLagCommandInput!) {
  setItemLag(input: $input)
}
    `;
export type SetItemLagMutationFn = Apollo.MutationFunction<SetItemLagMutation, SetItemLagMutationVariables>;

/**
 * __useSetItemLagMutation__
 *
 * To run a mutation, you first call `useSetItemLagMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetItemLagMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setItemLagMutation, { data, loading, error }] = useSetItemLagMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSetItemLagMutation(baseOptions?: Apollo.MutationHookOptions<SetItemLagMutation, SetItemLagMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetItemLagMutation, SetItemLagMutationVariables>(SetItemLagDocument, options);
      }
export type SetItemLagMutationHookResult = ReturnType<typeof useSetItemLagMutation>;
export type SetItemLagMutationResult = Apollo.MutationResult<SetItemLagMutation>;
export type SetItemLagMutationOptions = Apollo.BaseMutationOptions<SetItemLagMutation, SetItemLagMutationVariables>;
export const ExtendItemUsingDurationCommandDocument = gql`
    mutation ExtendItemUsingDurationCommand($input: ExtendItemUsingDurationCommandInput!) {
  extendItemUsingDuration(input: $input)
}
    `;
export type ExtendItemUsingDurationCommandMutationFn = Apollo.MutationFunction<ExtendItemUsingDurationCommandMutation, ExtendItemUsingDurationCommandMutationVariables>;

/**
 * __useExtendItemUsingDurationCommandMutation__
 *
 * To run a mutation, you first call `useExtendItemUsingDurationCommandMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useExtendItemUsingDurationCommandMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [extendItemUsingDurationCommandMutation, { data, loading, error }] = useExtendItemUsingDurationCommandMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useExtendItemUsingDurationCommandMutation(baseOptions?: Apollo.MutationHookOptions<ExtendItemUsingDurationCommandMutation, ExtendItemUsingDurationCommandMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ExtendItemUsingDurationCommandMutation, ExtendItemUsingDurationCommandMutationVariables>(ExtendItemUsingDurationCommandDocument, options);
      }
export type ExtendItemUsingDurationCommandMutationHookResult = ReturnType<typeof useExtendItemUsingDurationCommandMutation>;
export type ExtendItemUsingDurationCommandMutationResult = Apollo.MutationResult<ExtendItemUsingDurationCommandMutation>;
export type ExtendItemUsingDurationCommandMutationOptions = Apollo.BaseMutationOptions<ExtendItemUsingDurationCommandMutation, ExtendItemUsingDurationCommandMutationVariables>;
export const GetItemFieldsDocument = gql`
    query GetItemFields($itemId: ID!) {
  item(id: $itemId) {
    id
    customFields {
      id
      name
      value
    }
  }
}
    `;

/**
 * __useGetItemFieldsQuery__
 *
 * To run a query within a React component, call `useGetItemFieldsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetItemFieldsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetItemFieldsQuery({
 *   variables: {
 *      itemId: // value for 'itemId'
 *   },
 * });
 */
export function useGetItemFieldsQuery(baseOptions: Apollo.QueryHookOptions<GetItemFieldsQuery, GetItemFieldsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetItemFieldsQuery, GetItemFieldsQueryVariables>(GetItemFieldsDocument, options);
      }
export function useGetItemFieldsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetItemFieldsQuery, GetItemFieldsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetItemFieldsQuery, GetItemFieldsQueryVariables>(GetItemFieldsDocument, options);
        }
export type GetItemFieldsQueryHookResult = ReturnType<typeof useGetItemFieldsQuery>;
export type GetItemFieldsLazyQueryHookResult = ReturnType<typeof useGetItemFieldsLazyQuery>;
export type GetItemFieldsQueryResult = Apollo.QueryResult<GetItemFieldsQuery, GetItemFieldsQueryVariables>;
export const SetItemCustomFieldDocument = gql`
    mutation SetItemCustomField($input: SetItemCustomFieldCommandInput!) {
  setItemCustomField(input: $input)
}
    `;
export type SetItemCustomFieldMutationFn = Apollo.MutationFunction<SetItemCustomFieldMutation, SetItemCustomFieldMutationVariables>;

/**
 * __useSetItemCustomFieldMutation__
 *
 * To run a mutation, you first call `useSetItemCustomFieldMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetItemCustomFieldMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setItemCustomFieldMutation, { data, loading, error }] = useSetItemCustomFieldMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSetItemCustomFieldMutation(baseOptions?: Apollo.MutationHookOptions<SetItemCustomFieldMutation, SetItemCustomFieldMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetItemCustomFieldMutation, SetItemCustomFieldMutationVariables>(SetItemCustomFieldDocument, options);
      }
export type SetItemCustomFieldMutationHookResult = ReturnType<typeof useSetItemCustomFieldMutation>;
export type SetItemCustomFieldMutationResult = Apollo.MutationResult<SetItemCustomFieldMutation>;
export type SetItemCustomFieldMutationOptions = Apollo.BaseMutationOptions<SetItemCustomFieldMutation, SetItemCustomFieldMutationVariables>;
export const SetItemColorwayDocument = gql`
    mutation SetItemColorway($input: SetItemColorwayCommandInput!) {
  setItemColorway(input: $input)
}
    `;
export type SetItemColorwayMutationFn = Apollo.MutationFunction<SetItemColorwayMutation, SetItemColorwayMutationVariables>;

/**
 * __useSetItemColorwayMutation__
 *
 * To run a mutation, you first call `useSetItemColorwayMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetItemColorwayMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setItemColorwayMutation, { data, loading, error }] = useSetItemColorwayMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSetItemColorwayMutation(baseOptions?: Apollo.MutationHookOptions<SetItemColorwayMutation, SetItemColorwayMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetItemColorwayMutation, SetItemColorwayMutationVariables>(SetItemColorwayDocument, options);
      }
export type SetItemColorwayMutationHookResult = ReturnType<typeof useSetItemColorwayMutation>;
export type SetItemColorwayMutationResult = Apollo.MutationResult<SetItemColorwayMutation>;
export type SetItemColorwayMutationOptions = Apollo.BaseMutationOptions<SetItemColorwayMutation, SetItemColorwayMutationVariables>;
export const UpdateItemLocalFieldsDocument = gql`
    query UpdateItemLocalFields($itemId: ID!) {
  item(id: $itemId) {
    id
    title
    subtitle
    customFields {
      id
      name
      value
    }
  }
}
    `;

/**
 * __useUpdateItemLocalFieldsQuery__
 *
 * To run a query within a React component, call `useUpdateItemLocalFieldsQuery` and pass it any options that fit your needs.
 * When your component renders, `useUpdateItemLocalFieldsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUpdateItemLocalFieldsQuery({
 *   variables: {
 *      itemId: // value for 'itemId'
 *   },
 * });
 */
export function useUpdateItemLocalFieldsQuery(baseOptions: Apollo.QueryHookOptions<UpdateItemLocalFieldsQuery, UpdateItemLocalFieldsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UpdateItemLocalFieldsQuery, UpdateItemLocalFieldsQueryVariables>(UpdateItemLocalFieldsDocument, options);
      }
export function useUpdateItemLocalFieldsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UpdateItemLocalFieldsQuery, UpdateItemLocalFieldsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UpdateItemLocalFieldsQuery, UpdateItemLocalFieldsQueryVariables>(UpdateItemLocalFieldsDocument, options);
        }
export type UpdateItemLocalFieldsQueryHookResult = ReturnType<typeof useUpdateItemLocalFieldsQuery>;
export type UpdateItemLocalFieldsLazyQueryHookResult = ReturnType<typeof useUpdateItemLocalFieldsLazyQuery>;
export type UpdateItemLocalFieldsQueryResult = Apollo.QueryResult<UpdateItemLocalFieldsQuery, UpdateItemLocalFieldsQueryVariables>;
export const SetItemLockedDocument = gql`
    mutation SetItemLocked($input: SetItemLockedCommandInput!) {
  setItemLocked(input: $input)
}
    `;
export type SetItemLockedMutationFn = Apollo.MutationFunction<SetItemLockedMutation, SetItemLockedMutationVariables>;

/**
 * __useSetItemLockedMutation__
 *
 * To run a mutation, you first call `useSetItemLockedMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetItemLockedMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setItemLockedMutation, { data, loading, error }] = useSetItemLockedMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSetItemLockedMutation(baseOptions?: Apollo.MutationHookOptions<SetItemLockedMutation, SetItemLockedMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetItemLockedMutation, SetItemLockedMutationVariables>(SetItemLockedDocument, options);
      }
export type SetItemLockedMutationHookResult = ReturnType<typeof useSetItemLockedMutation>;
export type SetItemLockedMutationResult = Apollo.MutationResult<SetItemLockedMutation>;
export type SetItemLockedMutationOptions = Apollo.BaseMutationOptions<SetItemLockedMutation, SetItemLockedMutationVariables>;
export const CloneItemDocument = gql`
    mutation CloneItem($input: CloneItemCommandInput!) {
  cloneItem(input: $input)
}
    `;
export type CloneItemMutationFn = Apollo.MutationFunction<CloneItemMutation, CloneItemMutationVariables>;

/**
 * __useCloneItemMutation__
 *
 * To run a mutation, you first call `useCloneItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCloneItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cloneItemMutation, { data, loading, error }] = useCloneItemMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCloneItemMutation(baseOptions?: Apollo.MutationHookOptions<CloneItemMutation, CloneItemMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CloneItemMutation, CloneItemMutationVariables>(CloneItemDocument, options);
      }
export type CloneItemMutationHookResult = ReturnType<typeof useCloneItemMutation>;
export type CloneItemMutationResult = Apollo.MutationResult<CloneItemMutation>;
export type CloneItemMutationOptions = Apollo.BaseMutationOptions<CloneItemMutation, CloneItemMutationVariables>;
export const DeleteItemDocument = gql`
    mutation DeleteItem($input: DeleteItemCommandInput!) {
  deleteItem(input: $input) {
    success
    message
  }
}
    `;
export type DeleteItemMutationFn = Apollo.MutationFunction<DeleteItemMutation, DeleteItemMutationVariables>;

/**
 * __useDeleteItemMutation__
 *
 * To run a mutation, you first call `useDeleteItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteItemMutation, { data, loading, error }] = useDeleteItemMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteItemMutation(baseOptions?: Apollo.MutationHookOptions<DeleteItemMutation, DeleteItemMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteItemMutation, DeleteItemMutationVariables>(DeleteItemDocument, options);
      }
export type DeleteItemMutationHookResult = ReturnType<typeof useDeleteItemMutation>;
export type DeleteItemMutationResult = Apollo.MutationResult<DeleteItemMutation>;
export type DeleteItemMutationOptions = Apollo.BaseMutationOptions<DeleteItemMutation, DeleteItemMutationVariables>;
export const RestoreItemDocument = gql`
    mutation RestoreItem($input: RestoreItemCommandInput!) {
  restoreItem(input: $input)
}
    `;
export type RestoreItemMutationFn = Apollo.MutationFunction<RestoreItemMutation, RestoreItemMutationVariables>;

/**
 * __useRestoreItemMutation__
 *
 * To run a mutation, you first call `useRestoreItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRestoreItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [restoreItemMutation, { data, loading, error }] = useRestoreItemMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRestoreItemMutation(baseOptions?: Apollo.MutationHookOptions<RestoreItemMutation, RestoreItemMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RestoreItemMutation, RestoreItemMutationVariables>(RestoreItemDocument, options);
      }
export type RestoreItemMutationHookResult = ReturnType<typeof useRestoreItemMutation>;
export type RestoreItemMutationResult = Apollo.MutationResult<RestoreItemMutation>;
export type RestoreItemMutationOptions = Apollo.BaseMutationOptions<RestoreItemMutation, RestoreItemMutationVariables>;
export const MoveItemOnTimelineDocument = gql`
    mutation MoveItemOnTimeline($input: MoveItemOnTimelineCommandInput!) {
  moveItemOnTimeline(input: $input) {
    message
    error {
      __typename
    }
  }
}
    `;
export type MoveItemOnTimelineMutationFn = Apollo.MutationFunction<MoveItemOnTimelineMutation, MoveItemOnTimelineMutationVariables>;

/**
 * __useMoveItemOnTimelineMutation__
 *
 * To run a mutation, you first call `useMoveItemOnTimelineMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMoveItemOnTimelineMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [moveItemOnTimelineMutation, { data, loading, error }] = useMoveItemOnTimelineMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useMoveItemOnTimelineMutation(baseOptions?: Apollo.MutationHookOptions<MoveItemOnTimelineMutation, MoveItemOnTimelineMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MoveItemOnTimelineMutation, MoveItemOnTimelineMutationVariables>(MoveItemOnTimelineDocument, options);
      }
export type MoveItemOnTimelineMutationHookResult = ReturnType<typeof useMoveItemOnTimelineMutation>;
export type MoveItemOnTimelineMutationResult = Apollo.MutationResult<MoveItemOnTimelineMutation>;
export type MoveItemOnTimelineMutationOptions = Apollo.BaseMutationOptions<MoveItemOnTimelineMutation, MoveItemOnTimelineMutationVariables>;
export const MoveItemsOnTimelineDocument = gql`
    mutation MoveItemsOnTimeline($input: MoveItemsOnTimelineCommandInput!) {
  moveItemsOnTimeline(input: $input) {
    message
    error {
      __typename
    }
  }
}
    `;
export type MoveItemsOnTimelineMutationFn = Apollo.MutationFunction<MoveItemsOnTimelineMutation, MoveItemsOnTimelineMutationVariables>;

/**
 * __useMoveItemsOnTimelineMutation__
 *
 * To run a mutation, you first call `useMoveItemsOnTimelineMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMoveItemsOnTimelineMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [moveItemsOnTimelineMutation, { data, loading, error }] = useMoveItemsOnTimelineMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useMoveItemsOnTimelineMutation(baseOptions?: Apollo.MutationHookOptions<MoveItemsOnTimelineMutation, MoveItemsOnTimelineMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MoveItemsOnTimelineMutation, MoveItemsOnTimelineMutationVariables>(MoveItemsOnTimelineDocument, options);
      }
export type MoveItemsOnTimelineMutationHookResult = ReturnType<typeof useMoveItemsOnTimelineMutation>;
export type MoveItemsOnTimelineMutationResult = Apollo.MutationResult<MoveItemsOnTimelineMutation>;
export type MoveItemsOnTimelineMutationOptions = Apollo.BaseMutationOptions<MoveItemsOnTimelineMutation, MoveItemsOnTimelineMutationVariables>;
export const MoveItemToClipboardDocument = gql`
    mutation MoveItemToClipboard($input: MoveItemToClipboardCommandInput!) {
  moveItemToClipboard(input: $input)
}
    `;
export type MoveItemToClipboardMutationFn = Apollo.MutationFunction<MoveItemToClipboardMutation, MoveItemToClipboardMutationVariables>;

/**
 * __useMoveItemToClipboardMutation__
 *
 * To run a mutation, you first call `useMoveItemToClipboardMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMoveItemToClipboardMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [moveItemToClipboardMutation, { data, loading, error }] = useMoveItemToClipboardMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useMoveItemToClipboardMutation(baseOptions?: Apollo.MutationHookOptions<MoveItemToClipboardMutation, MoveItemToClipboardMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MoveItemToClipboardMutation, MoveItemToClipboardMutationVariables>(MoveItemToClipboardDocument, options);
      }
export type MoveItemToClipboardMutationHookResult = ReturnType<typeof useMoveItemToClipboardMutation>;
export type MoveItemToClipboardMutationResult = Apollo.MutationResult<MoveItemToClipboardMutation>;
export type MoveItemToClipboardMutationOptions = Apollo.BaseMutationOptions<MoveItemToClipboardMutation, MoveItemToClipboardMutationVariables>;
export const MoveProcessInRunDocument = gql`
    mutation MoveProcessInRun($input: MoveProcessInRunCommandInput!) {
  moveProcessInRun(input: $input)
}
    `;
export type MoveProcessInRunMutationFn = Apollo.MutationFunction<MoveProcessInRunMutation, MoveProcessInRunMutationVariables>;

/**
 * __useMoveProcessInRunMutation__
 *
 * To run a mutation, you first call `useMoveProcessInRunMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMoveProcessInRunMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [moveProcessInRunMutation, { data, loading, error }] = useMoveProcessInRunMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useMoveProcessInRunMutation(baseOptions?: Apollo.MutationHookOptions<MoveProcessInRunMutation, MoveProcessInRunMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MoveProcessInRunMutation, MoveProcessInRunMutationVariables>(MoveProcessInRunDocument, options);
      }
export type MoveProcessInRunMutationHookResult = ReturnType<typeof useMoveProcessInRunMutation>;
export type MoveProcessInRunMutationResult = Apollo.MutationResult<MoveProcessInRunMutation>;
export type MoveProcessInRunMutationOptions = Apollo.BaseMutationOptions<MoveProcessInRunMutation, MoveProcessInRunMutationVariables>;
export const CreateProcessDocument = gql`
    mutation CreateProcess($input: CreateProcessCommandInput!) {
  result: createProcess(input: $input) {
    item: process {
      id
    }
  }
}
    `;
export type CreateProcessMutationFn = Apollo.MutationFunction<CreateProcessMutation, CreateProcessMutationVariables>;

/**
 * __useCreateProcessMutation__
 *
 * To run a mutation, you first call `useCreateProcessMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateProcessMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createProcessMutation, { data, loading, error }] = useCreateProcessMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateProcessMutation(baseOptions?: Apollo.MutationHookOptions<CreateProcessMutation, CreateProcessMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateProcessMutation, CreateProcessMutationVariables>(CreateProcessDocument, options);
      }
export type CreateProcessMutationHookResult = ReturnType<typeof useCreateProcessMutation>;
export type CreateProcessMutationResult = Apollo.MutationResult<CreateProcessMutation>;
export type CreateProcessMutationOptions = Apollo.BaseMutationOptions<CreateProcessMutation, CreateProcessMutationVariables>;
export const CreateRunDocument = gql`
    mutation CreateRun($input: CreateRunCommandInput!) {
  result: createRun(input: $input) {
    item: run {
      id
    }
  }
}
    `;
export type CreateRunMutationFn = Apollo.MutationFunction<CreateRunMutation, CreateRunMutationVariables>;

/**
 * __useCreateRunMutation__
 *
 * To run a mutation, you first call `useCreateRunMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateRunMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createRunMutation, { data, loading, error }] = useCreateRunMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateRunMutation(baseOptions?: Apollo.MutationHookOptions<CreateRunMutation, CreateRunMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateRunMutation, CreateRunMutationVariables>(CreateRunDocument, options);
      }
export type CreateRunMutationHookResult = ReturnType<typeof useCreateRunMutation>;
export type CreateRunMutationResult = Apollo.MutationResult<CreateRunMutation>;
export type CreateRunMutationOptions = Apollo.BaseMutationOptions<CreateRunMutation, CreateRunMutationVariables>;
export const CreateSourceDocument = gql`
    mutation CreateSource($input: CreateSourceCommandInput!) {
  result: createSource(input: $input) {
    item: source {
      id
    }
  }
}
    `;
export type CreateSourceMutationFn = Apollo.MutationFunction<CreateSourceMutation, CreateSourceMutationVariables>;

/**
 * __useCreateSourceMutation__
 *
 * To run a mutation, you first call `useCreateSourceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateSourceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createSourceMutation, { data, loading, error }] = useCreateSourceMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateSourceMutation(baseOptions?: Apollo.MutationHookOptions<CreateSourceMutation, CreateSourceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateSourceMutation, CreateSourceMutationVariables>(CreateSourceDocument, options);
      }
export type CreateSourceMutationHookResult = ReturnType<typeof useCreateSourceMutation>;
export type CreateSourceMutationResult = Apollo.MutationResult<CreateSourceMutation>;
export type CreateSourceMutationOptions = Apollo.BaseMutationOptions<CreateSourceMutation, CreateSourceMutationVariables>;
export const CreateSinkDocument = gql`
    mutation CreateSink($input: CreateSinkCommandInput!) {
  result: createSink(input: $input) {
    item: sink {
      id
    }
  }
}
    `;
export type CreateSinkMutationFn = Apollo.MutationFunction<CreateSinkMutation, CreateSinkMutationVariables>;

/**
 * __useCreateSinkMutation__
 *
 * To run a mutation, you first call `useCreateSinkMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateSinkMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createSinkMutation, { data, loading, error }] = useCreateSinkMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateSinkMutation(baseOptions?: Apollo.MutationHookOptions<CreateSinkMutation, CreateSinkMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateSinkMutation, CreateSinkMutationVariables>(CreateSinkDocument, options);
      }
export type CreateSinkMutationHookResult = ReturnType<typeof useCreateSinkMutation>;
export type CreateSinkMutationResult = Apollo.MutationResult<CreateSinkMutation>;
export type CreateSinkMutationOptions = Apollo.BaseMutationOptions<CreateSinkMutation, CreateSinkMutationVariables>;
export const LocateItemDocument = gql`
    query LocateItem($id: ID!) {
  item(id: $id) {
    id
    timelineUsage {
      startTime
      endTime
    }
  }
}
    `;

/**
 * __useLocateItemQuery__
 *
 * To run a query within a React component, call `useLocateItemQuery` and pass it any options that fit your needs.
 * When your component renders, `useLocateItemQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLocateItemQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useLocateItemQuery(baseOptions: Apollo.QueryHookOptions<LocateItemQuery, LocateItemQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LocateItemQuery, LocateItemQueryVariables>(LocateItemDocument, options);
      }
export function useLocateItemLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LocateItemQuery, LocateItemQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LocateItemQuery, LocateItemQueryVariables>(LocateItemDocument, options);
        }
export type LocateItemQueryHookResult = ReturnType<typeof useLocateItemQuery>;
export type LocateItemLazyQueryHookResult = ReturnType<typeof useLocateItemLazyQuery>;
export type LocateItemQueryResult = Apollo.QueryResult<LocateItemQuery, LocateItemQueryVariables>;
export const RunLockedDocument = gql`
    query RunLocked($id: ID!) {
  item(id: $id) {
    id
    ... on Run {
      locked
    }
  }
}
    `;

/**
 * __useRunLockedQuery__
 *
 * To run a query within a React component, call `useRunLockedQuery` and pass it any options that fit your needs.
 * When your component renders, `useRunLockedQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRunLockedQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRunLockedQuery(baseOptions: Apollo.QueryHookOptions<RunLockedQuery, RunLockedQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RunLockedQuery, RunLockedQueryVariables>(RunLockedDocument, options);
      }
export function useRunLockedLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RunLockedQuery, RunLockedQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RunLockedQuery, RunLockedQueryVariables>(RunLockedDocument, options);
        }
export type RunLockedQueryHookResult = ReturnType<typeof useRunLockedQuery>;
export type RunLockedLazyQueryHookResult = ReturnType<typeof useRunLockedLazyQuery>;
export type RunLockedQueryResult = Apollo.QueryResult<RunLockedQuery, RunLockedQueryVariables>;
export const ResizeItemOnTimelineDocument = gql`
    mutation ResizeItemOnTimeline($input: ResizeItemOnTimelineCommandInput!) {
  resizeItemOnTimeline(input: $input)
}
    `;
export type ResizeItemOnTimelineMutationFn = Apollo.MutationFunction<ResizeItemOnTimelineMutation, ResizeItemOnTimelineMutationVariables>;

/**
 * __useResizeItemOnTimelineMutation__
 *
 * To run a mutation, you first call `useResizeItemOnTimelineMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResizeItemOnTimelineMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resizeItemOnTimelineMutation, { data, loading, error }] = useResizeItemOnTimelineMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useResizeItemOnTimelineMutation(baseOptions?: Apollo.MutationHookOptions<ResizeItemOnTimelineMutation, ResizeItemOnTimelineMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ResizeItemOnTimelineMutation, ResizeItemOnTimelineMutationVariables>(ResizeItemOnTimelineDocument, options);
      }
export type ResizeItemOnTimelineMutationHookResult = ReturnType<typeof useResizeItemOnTimelineMutation>;
export type ResizeItemOnTimelineMutationResult = Apollo.MutationResult<ResizeItemOnTimelineMutation>;
export type ResizeItemOnTimelineMutationOptions = Apollo.BaseMutationOptions<ResizeItemOnTimelineMutation, ResizeItemOnTimelineMutationVariables>;
export const ResourceNameDocument = gql`
    query ResourceName($id: ID!) {
  resource(id: $id) {
    id
    name
  }
}
    `;

/**
 * __useResourceNameQuery__
 *
 * To run a query within a React component, call `useResourceNameQuery` and pass it any options that fit your needs.
 * When your component renders, `useResourceNameQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useResourceNameQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useResourceNameQuery(baseOptions: Apollo.QueryHookOptions<ResourceNameQuery, ResourceNameQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ResourceNameQuery, ResourceNameQueryVariables>(ResourceNameDocument, options);
      }
export function useResourceNameLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ResourceNameQuery, ResourceNameQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ResourceNameQuery, ResourceNameQueryVariables>(ResourceNameDocument, options);
        }
export type ResourceNameQueryHookResult = ReturnType<typeof useResourceNameQuery>;
export type ResourceNameLazyQueryHookResult = ReturnType<typeof useResourceNameLazyQuery>;
export type ResourceNameQueryResult = Apollo.QueryResult<ResourceNameQuery, ResourceNameQueryVariables>;
export const SimpleResourceListDocument = gql`
    query SimpleResourceList {
  resources {
    id
    name
    displayIndex
  }
}
    `;

/**
 * __useSimpleResourceListQuery__
 *
 * To run a query within a React component, call `useSimpleResourceListQuery` and pass it any options that fit your needs.
 * When your component renders, `useSimpleResourceListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSimpleResourceListQuery({
 *   variables: {
 *   },
 * });
 */
export function useSimpleResourceListQuery(baseOptions?: Apollo.QueryHookOptions<SimpleResourceListQuery, SimpleResourceListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SimpleResourceListQuery, SimpleResourceListQueryVariables>(SimpleResourceListDocument, options);
      }
export function useSimpleResourceListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SimpleResourceListQuery, SimpleResourceListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SimpleResourceListQuery, SimpleResourceListQueryVariables>(SimpleResourceListDocument, options);
        }
export type SimpleResourceListQueryHookResult = ReturnType<typeof useSimpleResourceListQuery>;
export type SimpleResourceListLazyQueryHookResult = ReturnType<typeof useSimpleResourceListLazyQuery>;
export type SimpleResourceListQueryResult = Apollo.QueryResult<SimpleResourceListQuery, SimpleResourceListQueryVariables>;
export const ListResourceSettingsDocument = gql`
    query ListResourceSettings {
  resources {
    id
    name
    displayIndex
    allowProcesses
    allowSources
    allowSinks
    allowRuns
    allowReservations
  }
}
    `;

/**
 * __useListResourceSettingsQuery__
 *
 * To run a query within a React component, call `useListResourceSettingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListResourceSettingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListResourceSettingsQuery({
 *   variables: {
 *   },
 * });
 */
export function useListResourceSettingsQuery(baseOptions?: Apollo.QueryHookOptions<ListResourceSettingsQuery, ListResourceSettingsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListResourceSettingsQuery, ListResourceSettingsQueryVariables>(ListResourceSettingsDocument, options);
      }
export function useListResourceSettingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListResourceSettingsQuery, ListResourceSettingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListResourceSettingsQuery, ListResourceSettingsQueryVariables>(ListResourceSettingsDocument, options);
        }
export type ListResourceSettingsQueryHookResult = ReturnType<typeof useListResourceSettingsQuery>;
export type ListResourceSettingsLazyQueryHookResult = ReturnType<typeof useListResourceSettingsLazyQuery>;
export type ListResourceSettingsQueryResult = Apollo.QueryResult<ListResourceSettingsQuery, ListResourceSettingsQueryVariables>;
export const ResourceSettingsDocument = gql`
    query ResourceSettings($id: ID!) {
  resource(id: $id) {
    id
    name
    displayIndex
    allowProcesses
    allowSources
    allowSinks
    allowRuns
    allowReservations
    allowOverlappingItems
    salesOrderLane
    resourceType {
      id
    }
    defaultSchedule {
      startTime
      endTime
    }
  }
}
    `;

/**
 * __useResourceSettingsQuery__
 *
 * To run a query within a React component, call `useResourceSettingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useResourceSettingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useResourceSettingsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useResourceSettingsQuery(baseOptions: Apollo.QueryHookOptions<ResourceSettingsQuery, ResourceSettingsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ResourceSettingsQuery, ResourceSettingsQueryVariables>(ResourceSettingsDocument, options);
      }
export function useResourceSettingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ResourceSettingsQuery, ResourceSettingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ResourceSettingsQuery, ResourceSettingsQueryVariables>(ResourceSettingsDocument, options);
        }
export type ResourceSettingsQueryHookResult = ReturnType<typeof useResourceSettingsQuery>;
export type ResourceSettingsLazyQueryHookResult = ReturnType<typeof useResourceSettingsLazyQuery>;
export type ResourceSettingsQueryResult = Apollo.QueryResult<ResourceSettingsQuery, ResourceSettingsQueryVariables>;
export const ResourceScheduleDocument = gql`
    query ResourceSchedule($id: ID!, $from: DateTime!, $to: DateTime!) {
  resource(id: $id) {
    id
    name
    schedule(startTime: $from, endTime: $to) {
      startTime
      endTime
    }
  }
}
    `;

/**
 * __useResourceScheduleQuery__
 *
 * To run a query within a React component, call `useResourceScheduleQuery` and pass it any options that fit your needs.
 * When your component renders, `useResourceScheduleQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useResourceScheduleQuery({
 *   variables: {
 *      id: // value for 'id'
 *      from: // value for 'from'
 *      to: // value for 'to'
 *   },
 * });
 */
export function useResourceScheduleQuery(baseOptions: Apollo.QueryHookOptions<ResourceScheduleQuery, ResourceScheduleQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ResourceScheduleQuery, ResourceScheduleQueryVariables>(ResourceScheduleDocument, options);
      }
export function useResourceScheduleLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ResourceScheduleQuery, ResourceScheduleQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ResourceScheduleQuery, ResourceScheduleQueryVariables>(ResourceScheduleDocument, options);
        }
export type ResourceScheduleQueryHookResult = ReturnType<typeof useResourceScheduleQuery>;
export type ResourceScheduleLazyQueryHookResult = ReturnType<typeof useResourceScheduleLazyQuery>;
export type ResourceScheduleQueryResult = Apollo.QueryResult<ResourceScheduleQuery, ResourceScheduleQueryVariables>;
export const RenameResourceDocument = gql`
    mutation RenameResource($input: RenameResourceCommandInput!) {
  renameResource(input: $input)
}
    `;
export type RenameResourceMutationFn = Apollo.MutationFunction<RenameResourceMutation, RenameResourceMutationVariables>;

/**
 * __useRenameResourceMutation__
 *
 * To run a mutation, you first call `useRenameResourceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRenameResourceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [renameResourceMutation, { data, loading, error }] = useRenameResourceMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRenameResourceMutation(baseOptions?: Apollo.MutationHookOptions<RenameResourceMutation, RenameResourceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RenameResourceMutation, RenameResourceMutationVariables>(RenameResourceDocument, options);
      }
export type RenameResourceMutationHookResult = ReturnType<typeof useRenameResourceMutation>;
export type RenameResourceMutationResult = Apollo.MutationResult<RenameResourceMutation>;
export type RenameResourceMutationOptions = Apollo.BaseMutationOptions<RenameResourceMutation, RenameResourceMutationVariables>;
export const ReorderResourcesDocument = gql`
    mutation ReorderResources($input: ReorderResourcesCommandInput!) {
  reorderResources(input: $input)
}
    `;
export type ReorderResourcesMutationFn = Apollo.MutationFunction<ReorderResourcesMutation, ReorderResourcesMutationVariables>;

/**
 * __useReorderResourcesMutation__
 *
 * To run a mutation, you first call `useReorderResourcesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReorderResourcesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [reorderResourcesMutation, { data, loading, error }] = useReorderResourcesMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useReorderResourcesMutation(baseOptions?: Apollo.MutationHookOptions<ReorderResourcesMutation, ReorderResourcesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ReorderResourcesMutation, ReorderResourcesMutationVariables>(ReorderResourcesDocument, options);
      }
export type ReorderResourcesMutationHookResult = ReturnType<typeof useReorderResourcesMutation>;
export type ReorderResourcesMutationResult = Apollo.MutationResult<ReorderResourcesMutation>;
export type ReorderResourcesMutationOptions = Apollo.BaseMutationOptions<ReorderResourcesMutation, ReorderResourcesMutationVariables>;
export const SetResourceItemTypesAllowedDocument = gql`
    mutation SetResourceItemTypesAllowed($input: SetResourceItemTypesAllowedCommandInput!) {
  setResourceItemTypesAllowed(input: $input)
}
    `;
export type SetResourceItemTypesAllowedMutationFn = Apollo.MutationFunction<SetResourceItemTypesAllowedMutation, SetResourceItemTypesAllowedMutationVariables>;

/**
 * __useSetResourceItemTypesAllowedMutation__
 *
 * To run a mutation, you first call `useSetResourceItemTypesAllowedMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetResourceItemTypesAllowedMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setResourceItemTypesAllowedMutation, { data, loading, error }] = useSetResourceItemTypesAllowedMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSetResourceItemTypesAllowedMutation(baseOptions?: Apollo.MutationHookOptions<SetResourceItemTypesAllowedMutation, SetResourceItemTypesAllowedMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetResourceItemTypesAllowedMutation, SetResourceItemTypesAllowedMutationVariables>(SetResourceItemTypesAllowedDocument, options);
      }
export type SetResourceItemTypesAllowedMutationHookResult = ReturnType<typeof useSetResourceItemTypesAllowedMutation>;
export type SetResourceItemTypesAllowedMutationResult = Apollo.MutationResult<SetResourceItemTypesAllowedMutation>;
export type SetResourceItemTypesAllowedMutationOptions = Apollo.BaseMutationOptions<SetResourceItemTypesAllowedMutation, SetResourceItemTypesAllowedMutationVariables>;
export const SetResourceOverlapsAllowedDocument = gql`
    mutation SetResourceOverlapsAllowed($input: SetResourceOverlapsAllowedCommandInput!) {
  setResourceOverlapsAllowed(input: $input)
}
    `;
export type SetResourceOverlapsAllowedMutationFn = Apollo.MutationFunction<SetResourceOverlapsAllowedMutation, SetResourceOverlapsAllowedMutationVariables>;

/**
 * __useSetResourceOverlapsAllowedMutation__
 *
 * To run a mutation, you first call `useSetResourceOverlapsAllowedMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetResourceOverlapsAllowedMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setResourceOverlapsAllowedMutation, { data, loading, error }] = useSetResourceOverlapsAllowedMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSetResourceOverlapsAllowedMutation(baseOptions?: Apollo.MutationHookOptions<SetResourceOverlapsAllowedMutation, SetResourceOverlapsAllowedMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetResourceOverlapsAllowedMutation, SetResourceOverlapsAllowedMutationVariables>(SetResourceOverlapsAllowedDocument, options);
      }
export type SetResourceOverlapsAllowedMutationHookResult = ReturnType<typeof useSetResourceOverlapsAllowedMutation>;
export type SetResourceOverlapsAllowedMutationResult = Apollo.MutationResult<SetResourceOverlapsAllowedMutation>;
export type SetResourceOverlapsAllowedMutationOptions = Apollo.BaseMutationOptions<SetResourceOverlapsAllowedMutation, SetResourceOverlapsAllowedMutationVariables>;
export const CreateResourceDocument = gql`
    mutation CreateResource($input: CreateResourceCommandInput!) {
  createResource(input: $input)
}
    `;
export type CreateResourceMutationFn = Apollo.MutationFunction<CreateResourceMutation, CreateResourceMutationVariables>;

/**
 * __useCreateResourceMutation__
 *
 * To run a mutation, you first call `useCreateResourceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateResourceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createResourceMutation, { data, loading, error }] = useCreateResourceMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateResourceMutation(baseOptions?: Apollo.MutationHookOptions<CreateResourceMutation, CreateResourceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateResourceMutation, CreateResourceMutationVariables>(CreateResourceDocument, options);
      }
export type CreateResourceMutationHookResult = ReturnType<typeof useCreateResourceMutation>;
export type CreateResourceMutationResult = Apollo.MutationResult<CreateResourceMutation>;
export type CreateResourceMutationOptions = Apollo.BaseMutationOptions<CreateResourceMutation, CreateResourceMutationVariables>;
export const DeleteResourceDocument = gql`
    mutation DeleteResource($input: DeleteResourceCommandInput!) {
  deleteResource(input: $input)
}
    `;
export type DeleteResourceMutationFn = Apollo.MutationFunction<DeleteResourceMutation, DeleteResourceMutationVariables>;

/**
 * __useDeleteResourceMutation__
 *
 * To run a mutation, you first call `useDeleteResourceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteResourceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteResourceMutation, { data, loading, error }] = useDeleteResourceMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteResourceMutation(baseOptions?: Apollo.MutationHookOptions<DeleteResourceMutation, DeleteResourceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteResourceMutation, DeleteResourceMutationVariables>(DeleteResourceDocument, options);
      }
export type DeleteResourceMutationHookResult = ReturnType<typeof useDeleteResourceMutation>;
export type DeleteResourceMutationResult = Apollo.MutationResult<DeleteResourceMutation>;
export type DeleteResourceMutationOptions = Apollo.BaseMutationOptions<DeleteResourceMutation, DeleteResourceMutationVariables>;
export const ResourceTypesDocument = gql`
    query ResourceTypes {
  resourceTypes {
    id
    name
  }
}
    `;

/**
 * __useResourceTypesQuery__
 *
 * To run a query within a React component, call `useResourceTypesQuery` and pass it any options that fit your needs.
 * When your component renders, `useResourceTypesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useResourceTypesQuery({
 *   variables: {
 *   },
 * });
 */
export function useResourceTypesQuery(baseOptions?: Apollo.QueryHookOptions<ResourceTypesQuery, ResourceTypesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ResourceTypesQuery, ResourceTypesQueryVariables>(ResourceTypesDocument, options);
      }
export function useResourceTypesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ResourceTypesQuery, ResourceTypesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ResourceTypesQuery, ResourceTypesQueryVariables>(ResourceTypesDocument, options);
        }
export type ResourceTypesQueryHookResult = ReturnType<typeof useResourceTypesQuery>;
export type ResourceTypesLazyQueryHookResult = ReturnType<typeof useResourceTypesLazyQuery>;
export type ResourceTypesQueryResult = Apollo.QueryResult<ResourceTypesQuery, ResourceTypesQueryVariables>;
export const SetResourceResourceTypeDocument = gql`
    mutation SetResourceResourceType($input: SetResourceResourceTypeCommandInput!) {
  setResourceResourceType(input: $input)
}
    `;
export type SetResourceResourceTypeMutationFn = Apollo.MutationFunction<SetResourceResourceTypeMutation, SetResourceResourceTypeMutationVariables>;

/**
 * __useSetResourceResourceTypeMutation__
 *
 * To run a mutation, you first call `useSetResourceResourceTypeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetResourceResourceTypeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setResourceResourceTypeMutation, { data, loading, error }] = useSetResourceResourceTypeMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSetResourceResourceTypeMutation(baseOptions?: Apollo.MutationHookOptions<SetResourceResourceTypeMutation, SetResourceResourceTypeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetResourceResourceTypeMutation, SetResourceResourceTypeMutationVariables>(SetResourceResourceTypeDocument, options);
      }
export type SetResourceResourceTypeMutationHookResult = ReturnType<typeof useSetResourceResourceTypeMutation>;
export type SetResourceResourceTypeMutationResult = Apollo.MutationResult<SetResourceResourceTypeMutation>;
export type SetResourceResourceTypeMutationOptions = Apollo.BaseMutationOptions<SetResourceResourceTypeMutation, SetResourceResourceTypeMutationVariables>;
export const SetDefaultResourceScheduleDocument = gql`
    mutation SetDefaultResourceSchedule($input: SetDefaultResourceScheduleCommandInput!) {
  setDefaultResourceSchedule(input: $input)
}
    `;
export type SetDefaultResourceScheduleMutationFn = Apollo.MutationFunction<SetDefaultResourceScheduleMutation, SetDefaultResourceScheduleMutationVariables>;

/**
 * __useSetDefaultResourceScheduleMutation__
 *
 * To run a mutation, you first call `useSetDefaultResourceScheduleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetDefaultResourceScheduleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setDefaultResourceScheduleMutation, { data, loading, error }] = useSetDefaultResourceScheduleMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSetDefaultResourceScheduleMutation(baseOptions?: Apollo.MutationHookOptions<SetDefaultResourceScheduleMutation, SetDefaultResourceScheduleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetDefaultResourceScheduleMutation, SetDefaultResourceScheduleMutationVariables>(SetDefaultResourceScheduleDocument, options);
      }
export type SetDefaultResourceScheduleMutationHookResult = ReturnType<typeof useSetDefaultResourceScheduleMutation>;
export type SetDefaultResourceScheduleMutationResult = Apollo.MutationResult<SetDefaultResourceScheduleMutation>;
export type SetDefaultResourceScheduleMutationOptions = Apollo.BaseMutationOptions<SetDefaultResourceScheduleMutation, SetDefaultResourceScheduleMutationVariables>;
export const SetResourceScheduleDocument = gql`
    mutation SetResourceSchedule($input: SetResourceScheduleCommandInput!) {
  setResourceSchedule(input: $input)
}
    `;
export type SetResourceScheduleMutationFn = Apollo.MutationFunction<SetResourceScheduleMutation, SetResourceScheduleMutationVariables>;

/**
 * __useSetResourceScheduleMutation__
 *
 * To run a mutation, you first call `useSetResourceScheduleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetResourceScheduleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setResourceScheduleMutation, { data, loading, error }] = useSetResourceScheduleMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSetResourceScheduleMutation(baseOptions?: Apollo.MutationHookOptions<SetResourceScheduleMutation, SetResourceScheduleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetResourceScheduleMutation, SetResourceScheduleMutationVariables>(SetResourceScheduleDocument, options);
      }
export type SetResourceScheduleMutationHookResult = ReturnType<typeof useSetResourceScheduleMutation>;
export type SetResourceScheduleMutationResult = Apollo.MutationResult<SetResourceScheduleMutation>;
export type SetResourceScheduleMutationOptions = Apollo.BaseMutationOptions<SetResourceScheduleMutation, SetResourceScheduleMutationVariables>;
export const ResourceFilterDocument = gql`
    query ResourceFilter {
  resources {
    id
    name
    displayIndex
  }
  myResourceFilter {
    id
    items {
      id
      resource {
        id
      }
    }
  }
}
    `;

/**
 * __useResourceFilterQuery__
 *
 * To run a query within a React component, call `useResourceFilterQuery` and pass it any options that fit your needs.
 * When your component renders, `useResourceFilterQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useResourceFilterQuery({
 *   variables: {
 *   },
 * });
 */
export function useResourceFilterQuery(baseOptions?: Apollo.QueryHookOptions<ResourceFilterQuery, ResourceFilterQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ResourceFilterQuery, ResourceFilterQueryVariables>(ResourceFilterDocument, options);
      }
export function useResourceFilterLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ResourceFilterQuery, ResourceFilterQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ResourceFilterQuery, ResourceFilterQueryVariables>(ResourceFilterDocument, options);
        }
export type ResourceFilterQueryHookResult = ReturnType<typeof useResourceFilterQuery>;
export type ResourceFilterLazyQueryHookResult = ReturnType<typeof useResourceFilterLazyQuery>;
export type ResourceFilterQueryResult = Apollo.QueryResult<ResourceFilterQuery, ResourceFilterQueryVariables>;
export const FilterResourceDocument = gql`
    mutation FilterResource($input: FilterResourceCommandInput!) {
  filterResource(input: $input)
}
    `;
export type FilterResourceMutationFn = Apollo.MutationFunction<FilterResourceMutation, FilterResourceMutationVariables>;

/**
 * __useFilterResourceMutation__
 *
 * To run a mutation, you first call `useFilterResourceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useFilterResourceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [filterResourceMutation, { data, loading, error }] = useFilterResourceMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useFilterResourceMutation(baseOptions?: Apollo.MutationHookOptions<FilterResourceMutation, FilterResourceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<FilterResourceMutation, FilterResourceMutationVariables>(FilterResourceDocument, options);
      }
export type FilterResourceMutationHookResult = ReturnType<typeof useFilterResourceMutation>;
export type FilterResourceMutationResult = Apollo.MutationResult<FilterResourceMutation>;
export type FilterResourceMutationOptions = Apollo.BaseMutationOptions<FilterResourceMutation, FilterResourceMutationVariables>;
export const TimelineResourcesDocument = gql`
    query TimelineResources($startTime: DateTime!, $endTime: DateTime!) {
  resources(useMyFilter: true) {
    id
    name
    displayIndex
    allowProcesses
    allowSources
    allowSinks
    allowRuns
    inventoryWorkstationId
    resourceType {
      id
    }
    allowOverlappingItems
    salesOrderLane
    items(startTime: $startTime, endTime: $endTime) {
      ...ResourceItemData
    }
    schedule(startTime: $startTime, endTime: $endTime) {
      startTime
      endTime
    }
  }
}
    ${ResourceItemDataFragmentDoc}`;

/**
 * __useTimelineResourcesQuery__
 *
 * To run a query within a React component, call `useTimelineResourcesQuery` and pass it any options that fit your needs.
 * When your component renders, `useTimelineResourcesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTimelineResourcesQuery({
 *   variables: {
 *      startTime: // value for 'startTime'
 *      endTime: // value for 'endTime'
 *   },
 * });
 */
export function useTimelineResourcesQuery(baseOptions: Apollo.QueryHookOptions<TimelineResourcesQuery, TimelineResourcesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TimelineResourcesQuery, TimelineResourcesQueryVariables>(TimelineResourcesDocument, options);
      }
export function useTimelineResourcesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TimelineResourcesQuery, TimelineResourcesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TimelineResourcesQuery, TimelineResourcesQueryVariables>(TimelineResourcesDocument, options);
        }
export type TimelineResourcesQueryHookResult = ReturnType<typeof useTimelineResourcesQuery>;
export type TimelineResourcesLazyQueryHookResult = ReturnType<typeof useTimelineResourcesLazyQuery>;
export type TimelineResourcesQueryResult = Apollo.QueryResult<TimelineResourcesQuery, TimelineResourcesQueryVariables>;
export const ResourceChangedDocument = gql`
    subscription ResourceChanged {
  resourceChanged {
    resources {
      id
      name
      displayIndex
      allowProcesses
      allowSources
      allowSinks
      allowRuns
      allowOverlappingItems
      salesOrderLane
      resourceType {
        id
      }
    }
  }
}
    `;

/**
 * __useResourceChangedSubscription__
 *
 * To run a query within a React component, call `useResourceChangedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useResourceChangedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useResourceChangedSubscription({
 *   variables: {
 *   },
 * });
 */
export function useResourceChangedSubscription(baseOptions?: Apollo.SubscriptionHookOptions<ResourceChangedSubscription, ResourceChangedSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<ResourceChangedSubscription, ResourceChangedSubscriptionVariables>(ResourceChangedDocument, options);
      }
export type ResourceChangedSubscriptionHookResult = ReturnType<typeof useResourceChangedSubscription>;
export type ResourceChangedSubscriptionResult = Apollo.SubscriptionResult<ResourceChangedSubscription>;
export const RunEditorDocument = gql`
    query RunEditor($runId: ID!) {
  item(id: $runId) {
    id
    locked
    ... on Process {
      runUsage {
        id
        runId
      }
    }
    ... on Run {
      duration
      timelineUsage {
        id
        resource {
          id
          allowProcesses
        }
      }
      resourceType {
        id
        name
        processData {
          fields {
            name
          }
        }
      }
      runUsages {
        id
        offset
        process {
          id
          title
          locked
          subtitle
          colorway
          conflictCount
          description
          duration
          lag
          taskIconId
          timelineUsage {
            id
            startTime
            endTime
            resourceId
          }
          inputs {
            id
            title
            colorway
            __typename
          }
          outputs {
            id
            title
            colorway
            __typename
          }
        }
      }
    }
  }
}
    `;

/**
 * __useRunEditorQuery__
 *
 * To run a query within a React component, call `useRunEditorQuery` and pass it any options that fit your needs.
 * When your component renders, `useRunEditorQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRunEditorQuery({
 *   variables: {
 *      runId: // value for 'runId'
 *   },
 * });
 */
export function useRunEditorQuery(baseOptions: Apollo.QueryHookOptions<RunEditorQuery, RunEditorQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RunEditorQuery, RunEditorQueryVariables>(RunEditorDocument, options);
      }
export function useRunEditorLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RunEditorQuery, RunEditorQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RunEditorQuery, RunEditorQueryVariables>(RunEditorDocument, options);
        }
export type RunEditorQueryHookResult = ReturnType<typeof useRunEditorQuery>;
export type RunEditorLazyQueryHookResult = ReturnType<typeof useRunEditorLazyQuery>;
export type RunEditorQueryResult = Apollo.QueryResult<RunEditorQuery, RunEditorQueryVariables>;
export const SearchDocument = gql`
    query Search($searchQuery: String!, $take: Int!, $months: Int!) {
  searchItems(search: $searchQuery, take: $take, months: $months) {
    __typename
    items {
      item {
        id
        title
        colorway
        timelineUsage {
          id
          startTime
          resource {
            id
            name
          }
        }
      }
      customField {
        name
        value
      }
    }
  }
}
    `;

/**
 * __useSearchQuery__
 *
 * To run a query within a React component, call `useSearchQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchQuery({
 *   variables: {
 *      searchQuery: // value for 'searchQuery'
 *      take: // value for 'take'
 *      months: // value for 'months'
 *   },
 * });
 */
export function useSearchQuery(baseOptions: Apollo.QueryHookOptions<SearchQuery, SearchQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SearchQuery, SearchQueryVariables>(SearchDocument, options);
      }
export function useSearchLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SearchQuery, SearchQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SearchQuery, SearchQueryVariables>(SearchDocument, options);
        }
export type SearchQueryHookResult = ReturnType<typeof useSearchQuery>;
export type SearchLazyQueryHookResult = ReturnType<typeof useSearchLazyQuery>;
export type SearchQueryResult = Apollo.QueryResult<SearchQuery, SearchQueryVariables>;
export const ItemCreatedDocument = gql`
    subscription ItemCreated {
  itemCreated {
    items {
      ...ResourceItemData
      ... on Process {
        inventoryWorkstationId
        runUsage {
          id
          runId
          offset
        }
      }
    }
  }
}
    ${ResourceItemDataFragmentDoc}`;

/**
 * __useItemCreatedSubscription__
 *
 * To run a query within a React component, call `useItemCreatedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useItemCreatedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useItemCreatedSubscription({
 *   variables: {
 *   },
 * });
 */
export function useItemCreatedSubscription(baseOptions?: Apollo.SubscriptionHookOptions<ItemCreatedSubscription, ItemCreatedSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<ItemCreatedSubscription, ItemCreatedSubscriptionVariables>(ItemCreatedDocument, options);
      }
export type ItemCreatedSubscriptionHookResult = ReturnType<typeof useItemCreatedSubscription>;
export type ItemCreatedSubscriptionResult = Apollo.SubscriptionResult<ItemCreatedSubscription>;
export const ItemDeletedDocument = gql`
    subscription ItemDeleted {
  itemDeleted {
    items {
      id
    }
  }
}
    `;

/**
 * __useItemDeletedSubscription__
 *
 * To run a query within a React component, call `useItemDeletedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useItemDeletedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useItemDeletedSubscription({
 *   variables: {
 *   },
 * });
 */
export function useItemDeletedSubscription(baseOptions?: Apollo.SubscriptionHookOptions<ItemDeletedSubscription, ItemDeletedSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<ItemDeletedSubscription, ItemDeletedSubscriptionVariables>(ItemDeletedDocument, options);
      }
export type ItemDeletedSubscriptionHookResult = ReturnType<typeof useItemDeletedSubscription>;
export type ItemDeletedSubscriptionResult = Apollo.SubscriptionResult<ItemDeletedSubscription>;
export const ItemChangedDocument = gql`
    subscription ItemChanged {
  itemDataChanged {
    items {
      id
      colorway
      title
      subtitle
      description
      locked
      lastPositioned
      ... on Process {
        taskIconId
        lag
      }
      ... on Run {
        lag
      }
      ... on Sink {
        lag
      }
      customFields {
        id
        name
        value
      }
    }
  }
}
    `;

/**
 * __useItemChangedSubscription__
 *
 * To run a query within a React component, call `useItemChangedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useItemChangedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useItemChangedSubscription({
 *   variables: {
 *   },
 * });
 */
export function useItemChangedSubscription(baseOptions?: Apollo.SubscriptionHookOptions<ItemChangedSubscription, ItemChangedSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<ItemChangedSubscription, ItemChangedSubscriptionVariables>(ItemChangedDocument, options);
      }
export type ItemChangedSubscriptionHookResult = ReturnType<typeof useItemChangedSubscription>;
export type ItemChangedSubscriptionResult = Apollo.SubscriptionResult<ItemChangedSubscription>;
export const ItemConflictStatusChangedDocument = gql`
    subscription ItemConflictStatusChanged {
  itemConflictStatusChanged {
    items {
      id
      conflictCount
    }
  }
}
    `;

/**
 * __useItemConflictStatusChangedSubscription__
 *
 * To run a query within a React component, call `useItemConflictStatusChangedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useItemConflictStatusChangedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useItemConflictStatusChangedSubscription({
 *   variables: {
 *   },
 * });
 */
export function useItemConflictStatusChangedSubscription(baseOptions?: Apollo.SubscriptionHookOptions<ItemConflictStatusChangedSubscription, ItemConflictStatusChangedSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<ItemConflictStatusChangedSubscription, ItemConflictStatusChangedSubscriptionVariables>(ItemConflictStatusChangedDocument, options);
      }
export type ItemConflictStatusChangedSubscriptionHookResult = ReturnType<typeof useItemConflictStatusChangedSubscription>;
export type ItemConflictStatusChangedSubscriptionResult = Apollo.SubscriptionResult<ItemConflictStatusChangedSubscription>;
export const ItemMovedDocument = gql`
    subscription ItemMoved {
  itemMoved {
    items {
      id
      locked
      lastPositioned
      conflictCount
      ... on Process {
        duration
        lag
        runUsage {
          id
          offset
          runId
        }
      }
      ... on Run {
        duration
        lag
      }
      timelineUsage {
        id
        startTime
        endTime
        resourceId
      }
    }
  }
}
    `;

/**
 * __useItemMovedSubscription__
 *
 * To run a query within a React component, call `useItemMovedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useItemMovedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useItemMovedSubscription({
 *   variables: {
 *   },
 * });
 */
export function useItemMovedSubscription(baseOptions?: Apollo.SubscriptionHookOptions<ItemMovedSubscription, ItemMovedSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<ItemMovedSubscription, ItemMovedSubscriptionVariables>(ItemMovedDocument, options);
      }
export type ItemMovedSubscriptionHookResult = ReturnType<typeof useItemMovedSubscription>;
export type ItemMovedSubscriptionResult = Apollo.SubscriptionResult<ItemMovedSubscription>;
export const ResourceCreatedDocument = gql`
    subscription ResourceCreated {
  resourceCreated {
    resources {
      id
      name
      displayIndex
      allowProcesses
      allowSources
      allowSinks
      allowRuns
      allowOverlappingItems
      salesOrderLane
      resourceType {
        id
      }
    }
  }
}
    `;

/**
 * __useResourceCreatedSubscription__
 *
 * To run a query within a React component, call `useResourceCreatedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useResourceCreatedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useResourceCreatedSubscription({
 *   variables: {
 *   },
 * });
 */
export function useResourceCreatedSubscription(baseOptions?: Apollo.SubscriptionHookOptions<ResourceCreatedSubscription, ResourceCreatedSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<ResourceCreatedSubscription, ResourceCreatedSubscriptionVariables>(ResourceCreatedDocument, options);
      }
export type ResourceCreatedSubscriptionHookResult = ReturnType<typeof useResourceCreatedSubscription>;
export type ResourceCreatedSubscriptionResult = Apollo.SubscriptionResult<ResourceCreatedSubscription>;
export const ResourceDeletedDocument = gql`
    subscription ResourceDeleted {
  resourceDeleted {
    resources {
      id
    }
  }
}
    `;

/**
 * __useResourceDeletedSubscription__
 *
 * To run a query within a React component, call `useResourceDeletedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useResourceDeletedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useResourceDeletedSubscription({
 *   variables: {
 *   },
 * });
 */
export function useResourceDeletedSubscription(baseOptions?: Apollo.SubscriptionHookOptions<ResourceDeletedSubscription, ResourceDeletedSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<ResourceDeletedSubscription, ResourceDeletedSubscriptionVariables>(ResourceDeletedDocument, options);
      }
export type ResourceDeletedSubscriptionHookResult = ReturnType<typeof useResourceDeletedSubscription>;
export type ResourceDeletedSubscriptionResult = Apollo.SubscriptionResult<ResourceDeletedSubscription>;
export const ResourceScheduleChangedDocument = gql`
    subscription ResourceScheduleChanged {
  resourceScheduleChanged {
    resources {
      id
    }
  }
}
    `;

/**
 * __useResourceScheduleChangedSubscription__
 *
 * To run a query within a React component, call `useResourceScheduleChangedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useResourceScheduleChangedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useResourceScheduleChangedSubscription({
 *   variables: {
 *   },
 * });
 */
export function useResourceScheduleChangedSubscription(baseOptions?: Apollo.SubscriptionHookOptions<ResourceScheduleChangedSubscription, ResourceScheduleChangedSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<ResourceScheduleChangedSubscription, ResourceScheduleChangedSubscriptionVariables>(ResourceScheduleChangedDocument, options);
      }
export type ResourceScheduleChangedSubscriptionHookResult = ReturnType<typeof useResourceScheduleChangedSubscription>;
export type ResourceScheduleChangedSubscriptionResult = Apollo.SubscriptionResult<ResourceScheduleChangedSubscription>;
export const CurrentUserDocument = gql`
    query CurrentUser {
  currentUser {
    name
    policies
    email
  }
}
    `;

/**
 * __useCurrentUserQuery__
 *
 * To run a query within a React component, call `useCurrentUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useCurrentUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCurrentUserQuery({
 *   variables: {
 *   },
 * });
 */
export function useCurrentUserQuery(baseOptions?: Apollo.QueryHookOptions<CurrentUserQuery, CurrentUserQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CurrentUserQuery, CurrentUserQueryVariables>(CurrentUserDocument, options);
      }
export function useCurrentUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CurrentUserQuery, CurrentUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CurrentUserQuery, CurrentUserQueryVariables>(CurrentUserDocument, options);
        }
export type CurrentUserQueryHookResult = ReturnType<typeof useCurrentUserQuery>;
export type CurrentUserLazyQueryHookResult = ReturnType<typeof useCurrentUserLazyQuery>;
export type CurrentUserQueryResult = Apollo.QueryResult<CurrentUserQuery, CurrentUserQueryVariables>;
export const GetWorkstationResourceRangeDocument = gql`
    query GetWorkstationResourceRange($id: ID!, $startTime: DateTime!, $endTime: DateTime!) {
  resource(id: $id) {
    id
    name
    resourceType {
      id
      processData {
        fields {
          name
        }
      }
      runData {
        fields {
          name
        }
      }
    }
    items(startTime: $startTime, endTime: $endTime) {
      __typename
      id
      title
      subtitle
      conflictCount
      colorway
      timelineUsage {
        id
        startTime
        endTime
      }
      description
      customFields {
        id
        name
        value
      }
      ... on Process {
        duration
        lag
        taskIconId
        runUsage {
          id
        }
        inventoryEntityId
      }
      ... on Run {
        duration
        lag
        runUsages {
          id
          process {
            id
            title
            subtitle
            conflictCount
            colorway
            timelineUsage {
              id
              startTime
              endTime
            }
            description
            customFields {
              id
              name
              value
            }
            duration
            lag
            taskIconId
            inventoryEntityId
          }
        }
      }
    }
    schedule(startTime: $startTime, endTime: $endTime) {
      startTime
      endTime
    }
  }
}
    `;

/**
 * __useGetWorkstationResourceRangeQuery__
 *
 * To run a query within a React component, call `useGetWorkstationResourceRangeQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWorkstationResourceRangeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWorkstationResourceRangeQuery({
 *   variables: {
 *      id: // value for 'id'
 *      startTime: // value for 'startTime'
 *      endTime: // value for 'endTime'
 *   },
 * });
 */
export function useGetWorkstationResourceRangeQuery(baseOptions: Apollo.QueryHookOptions<GetWorkstationResourceRangeQuery, GetWorkstationResourceRangeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetWorkstationResourceRangeQuery, GetWorkstationResourceRangeQueryVariables>(GetWorkstationResourceRangeDocument, options);
      }
export function useGetWorkstationResourceRangeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetWorkstationResourceRangeQuery, GetWorkstationResourceRangeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetWorkstationResourceRangeQuery, GetWorkstationResourceRangeQueryVariables>(GetWorkstationResourceRangeDocument, options);
        }
export type GetWorkstationResourceRangeQueryHookResult = ReturnType<typeof useGetWorkstationResourceRangeQuery>;
export type GetWorkstationResourceRangeLazyQueryHookResult = ReturnType<typeof useGetWorkstationResourceRangeLazyQuery>;
export type GetWorkstationResourceRangeQueryResult = Apollo.QueryResult<GetWorkstationResourceRangeQuery, GetWorkstationResourceRangeQueryVariables>;

export const SetResourceSalesOrderLaneDocument = gql`
    mutation SetResourceSalesOrderLane($input: SetResourceSalesOrderLaneCommandInput!) {
  setResourceSalesOrderLane(input: $input)
}
    `;
export type SetResourceSalesOrderLaneMutationFn = Apollo.MutationFunction<SetResourceSalesOrderLaneMutation, SetResourceSalesOrderLaneMutationVariables>;
export function useSetResourceSalesOrderLaneMutation(baseOptions?: Apollo.MutationHookOptions<SetResourceSalesOrderLaneMutation, SetResourceSalesOrderLaneMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetResourceSalesOrderLaneMutation, SetResourceSalesOrderLaneMutationVariables>(SetResourceSalesOrderLaneDocument, options);
      }
export type SetResourceSalesOrderLaneMutationHookResult = ReturnType<typeof useSetResourceSalesOrderLaneMutation>;
export type SetResourceSalesOrderLaneMutationResult = Apollo.MutationResult<SetResourceSalesOrderLaneMutation>;
export type SetResourceSalesOrderLaneMutationOptions = Apollo.BaseMutationOptions<SetResourceSalesOrderLaneMutation, SetResourceSalesOrderLaneMutationVariables>;
export const SalesOrderSyncStatusDocument = gql`
    query SalesOrderSyncStatus {
  salesOrderSyncStatus {
    lastRunAt
    lastError
    rowCount
    watermark
  }
}
    `;
export function useSalesOrderSyncStatusQuery(baseOptions?: Apollo.QueryHookOptions<SalesOrderSyncStatusQuery, SalesOrderSyncStatusQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SalesOrderSyncStatusQuery, SalesOrderSyncStatusQueryVariables>(SalesOrderSyncStatusDocument, options);
      }
export function useSalesOrderSyncStatusLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SalesOrderSyncStatusQuery, SalesOrderSyncStatusQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SalesOrderSyncStatusQuery, SalesOrderSyncStatusQueryVariables>(SalesOrderSyncStatusDocument, options);
        }
export type SalesOrderSyncStatusQueryHookResult = ReturnType<typeof useSalesOrderSyncStatusQuery>;
export type SalesOrderSyncStatusLazyQueryHookResult = ReturnType<typeof useSalesOrderSyncStatusLazyQuery>;
export type SalesOrderSyncStatusQueryResult = Apollo.QueryResult<SalesOrderSyncStatusQuery, SalesOrderSyncStatusQueryVariables>;
export const SyncSalesOrdersNowDocument = gql`
    mutation SyncSalesOrdersNow {
  syncSalesOrdersNow
}
    `;
export type SyncSalesOrdersNowMutationFn = Apollo.MutationFunction<SyncSalesOrdersNowMutation, SyncSalesOrdersNowMutationVariables>;
export function useSyncSalesOrdersNowMutation(baseOptions?: Apollo.MutationHookOptions<SyncSalesOrdersNowMutation, SyncSalesOrdersNowMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SyncSalesOrdersNowMutation, SyncSalesOrdersNowMutationVariables>(SyncSalesOrdersNowDocument, options);
      }
export type SyncSalesOrdersNowMutationHookResult = ReturnType<typeof useSyncSalesOrdersNowMutation>;
export type SyncSalesOrdersNowMutationResult = Apollo.MutationResult<SyncSalesOrdersNowMutation>;
export type SyncSalesOrdersNowMutationOptions = Apollo.BaseMutationOptions<SyncSalesOrdersNowMutation, SyncSalesOrdersNowMutationVariables>;
